// import React, { useEffect, useMemo, useRef, useState } from "react";
// import {
//   Grid,
//   Card,
//   CardContent,
//   Box,
//   Button,
//   Dialog,
//   DialogActions,
//   DialogContent,
//   DialogContentText,
//   DialogTitle,
//   Pagination,
//   IconButton,
//   Tabs,
//   Tab,
//   TextField,
//   Chip,
//   Select,
//   Menu,
//   MenuItem,
//   Typography,
// } from "@mui/material";
// import { DataGrid } from "@mui/x-data-grid";
// import MoreVertIcon from "@mui/icons-material/MoreVert";
// import ReusableTable from "../../component/ui/ReusableTable";
// import { saveAs } from "file-saver";
// import { useLocation, useNavigate } from "react-router-dom";
// import "../../styles/Booking.scss";
// import "../../styles/UserStyles.css";
// import SearchAndButtonTab from "../../component/ui/SearchAndButtonTab";
// import {
//   formatDateWithAmPm,
//   formatDateWithAmPmBooking,
//   getStatusClass,
// } from "../../Style";
// import {
//   BOOKING_AIRPORT_DETAILS,
//   EDIT_BOOKINGS,
//   VIEW_BOOKINGS,
// } from "../../component/common/Routes/AppRoutes";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   VENDOR_BOOKING_AIRPORT_DETAILS,
//   VENDOR_EDIT_BOOKINGS,
//   VENDOR_VIEW_BOOKINGS,
// } from "../../component/common/Routes/VendorRoutes";
// import {
//   CUSTOMER_BOOKING_AIRPORT_DETAILS,
//   CUSTOMER_VIEW_BOOKINGS,
// } from "../../component/common/Routes/CustomerRoutes";
// import {
//   fetchBookingsRequest,
//   deleteBookingRequest,
//   fetchCustomerBookingsRequest,
//   resetBookingDetails,
//   fetchComplementaryBookingsRequest,
//   fetchInstantBookingsRequest,
//   getAllBookingsRequest,
//   fetchAllBookingRequest,
//   resendRazorpayLinkRequest,
//   resendRazorpayLinkReset,
//   updatePaymentStatusReset,
//   updatePaymentStatusRequest,
//   updateBookingStatusReset,
//   updateBookingStatusRequest,
// } from "../../redux/Bookings/BookingAction";

// import CustomButton from "../../component/ui/FormFields/Button";
// import { toast, ToastContainer } from "react-toastify";
// import Loading from "../../component/ui/Loading";
// import nodata from "../../assets/nodata.jpg";
// import axiosInstance from "../../redux/instance/AxiosInstance";
// import PaymentStatusDialog from "./PaymentStatusDialog";

// const BookingList = () => {
//   const dispatch = useDispatch();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const bookings = useSelector((state) => state.booking.bookings || []);
//   const totalRecord = useSelector((state) => state.booking?.totalRecords || 0);
//   const totalPages = useSelector((state) => state.booking?.totalPages || 0);
//   const deleteSuccess = useSelector((state) => state.booking?.message);

//   const { loading: viewListLoading, deleteLoading } = useSelector(
//     (state) => state.booking
//   );

//   const {
//     loading: resendPaymentLoading,
//     success: resendPaymentSuccess,
//     resendPaymentError,
//     data: resendPaymentData,
//   } = useSelector((state) => state.booking);

//   const { user } = useSelector((state) => state.auth);
//   const isStaff = user.role !== "Customer" && user.role !== "Vendor";

//   const tab = location?.state?.tab ?? (isStaff ? 0 : 2);
//   const pageNumber = location?.state?.page ?? 0;
 
//   const complemetStatus = location?.state?.complementaryStatus ?? 2;
//   const instantBookingStatus = location?.state?.instantStatus ?? 2;

//   const permissions = useMemo(() => {
//     let safePermissions = {};
//     try {
//       if (user?.permissions) {
//         safePermissions =
//           typeof user.permissions === "string"
//             ? JSON.parse(user.permissions)
//             : user.permissions;
//       }
//     } catch (error) {
//       safePermissions = {};
//     }
//     return safePermissions;
//   }, [user]);

//   const {
//     loading: updatePaymentLoading,
//     success: updatePaymentSuccess,
//     error: updatePaymentError,
//   } = useSelector((state) => state.booking.updatePaymentStatus || {});

//   const {
//     loading: updateBookingLoading,
//     success: updateBookingSuccess,
//     error: updateBookingError,
//   } = useSelector((state) => state.booking.updateBookingStatus || {});

//   const [type, setType] = useState(tab);
//   const searchNavigateQuery = location.state?.searchQuery ?? "";

//   const [searchQuery, setSearchQuery] = useState(searchNavigateQuery ?? "");

//   const [searchColumn, setSearchColumn] = useState("");
//   const [open, setOpen] = useState(false);
//   const [bookingToDelete, setBookingToDelete] = useState(null);
//   const [page, setPage] = useState(0);
//   console.log("page",page)
//   const [pageSize, setPageSize] = useState(10);
  
//   // Update page when location state changes
//   useEffect(() => {
//     if (location?.state?.page !== undefined) {
//       setPage(location.state.page);
//     }
//   }, [location?.state?.page]);
//   const [complementaryStatus, setComplementaryStatus] =
//     useState(complemetStatus);
//   const [instantStatus, setInstantStatus] = useState(instantBookingStatus);
//   const [cancelReason, setCancelReason] = useState("");
//   const [allBookings, setAllBookings] = useState([]);
//   const [fromDate, setFromDate] = useState("");
//   const [toDate, setToDate] = useState("");
//   const [updatePaymentDialogOpen, setUpdatePaymentDialogOpen] = useState(false);
//   const [updateBookingDialogOpen, setUpdateBookingDialogOpen] = useState(false);
//   const [selectedBooking, setSelectedBooking] = useState(null);
//   const [paymentStatus, setPaymentStatus] = useState("1");
//   const [referenceNumber, setReferenceNumber] = useState("");
//   const [bookingStatus, setBookingStatus] = useState("1");
//   const [booked_type, setBooked_type] = useState(1);

//   const currentDate = new Date().toISOString().split("T")[0];
//   const searchTimerRef = useRef(null);
//   const isInitialLoad = useRef(true);
//   const rowsPerPage = pageSize; // Use pageSize state instead of hardcoded value

//   const bookingFilterHeaders = [
//     { value: "booking_serial_no", label: "Booking Number" },
//     { value: "date_of_booking", label: "Booking Date" },
//     { value: "booked_user_name", label: "Booked By" },
//     { value: "booked_for", label: "Booked For" },
//     { value: "service", label: "Service" },
//     { value: "service_type_label", label: "Service Type" },
//   ];

//   // Fetch data function
//   const fetchData = (
//     currentPage = page,
//     tabType = type,
//     search = searchQuery,
//     searchBy = searchColumn,
//     includeDates = false,
//     pageSizeOverride = pageSize
//   ) => {
//     dispatch(resetBookingDetails());

//     let bookedType = 1;
//     if (tabType === 1 || tabType === 2 || tabType === 3) {
//       bookedType = 1;
//     } else if (tabType === 4) {
//       bookedType = 2;
//     } else if (tabType === 5) {
//       bookedType = 3;
//     }

//     const dateParams = {};
//     if (includeDates) {
//       if (fromDate) dateParams.from_date = fromDate;
//       if (toDate) dateParams.to_date = toDate;
//     }

//     const apiPage = currentPage + 1; // Convert 0-based to 1-based for API

//     if (user.role === "Customer" || user.role === "Vendor") {
//       dispatch(
//         fetchCustomerBookingsRequest({
//           customer_id: user.customer_id || "",
//           vendor_id: user.vendor_id || "",
//           pageNo: apiPage,
//           pageSize: pageSizeOverride,
//           type:
//             tabType === 2
//               ? "upcoming"
//               : tabType === 1
//               ? "previous"
//               : tabType === 3
//               ? "cancelled"
//               : "upcoming",
//           booked_type: "all",
//           currentDate,
//           search: search || "",
//           search_by: searchBy || "",
//           ...dateParams,
//         })
//       );
//     } else {
//       if (tabType === 0) {
//         dispatch(
//           fetchAllBookingRequest({
//             pageNo: apiPage,
//             pagesize: pageSizeOverride,
//             search: search || "",
//             search_by: searchBy || "",
//             ...dateParams,
//           })
//         );
//       } else if (tabType === 4) {
//         dispatch(
//           fetchComplementaryBookingsRequest({
//             pageNo: apiPage,
//             pagesize: pageSizeOverride,
//             approove_status: complementaryStatus,
//             currentDate,
//             search: search || "",
//             search_by: searchBy || "",
//             ...dateParams,
//           })
//         );
//       } else if (tabType === 5) {
//         let instantBookingType;
//         switch (instantStatus) {
//           case 1:
//             instantBookingType = "previous";
//             break;
//           case 2:
//             instantBookingType = "upcoming";
//             break;
//           case 3:
//             instantBookingType = "cancelled";
//             break;
//           default:
//             instantBookingType = "upcoming";
//         }

//         dispatch(
//           fetchInstantBookingsRequest({
//             pageNo: apiPage,
//             pagesize: pageSizeOverride,
//             type: instantBookingType,
//             currentDate,
//             search: search || "",
//             search_by: searchBy || "",
//             ...dateParams,
//           })
//         );
//       } else {
//         dispatch(
//           fetchBookingsRequest({
//             pageNo: apiPage,
//             pagesize: pageSizeOverride,
//             type:
//               tabType === 2
//                 ? "upcoming"
//                 : tabType === 1
//                 ? "previous"
//                 : tabType === 3
//                 ? "cancelled"
//                 : "upcoming",
//             booked_type: bookedType,
//             currentDate,
//             search: search || "",
//             search_by: searchBy || "",
//             ...dateParams,
//           })
//         );
//       }
//     }
//   };

//   const immediateSearchQueryRef = useRef(searchNavigateQuery ?? ""); // Add this ref

//   // Update the search handler to also update the ref
//   const handleSearch = (query, column) => {

//     setSearchQuery(query);
//     immediateSearchQueryRef.current = query; // Update the ref immediately

//     if (column !== undefined) {
//       setSearchColumn(column);
//     }

//     if (searchTimerRef.current) {
//       clearTimeout(searchTimerRef.current);
//     }

//     if (query || query === "") {
//       searchTimerRef.current = setTimeout(() => {
//         setPage(0);
//         fetchData(0, type, query, column || searchColumn);
//       }, 1000);
//     }
//   };
//   const handleColumnChange = (column) => {
//     setSearchColumn(column);
//   };

//   const handleDateFilterSubmit = () => {
//     setPage(0);
//     fetchData(0, type, searchQuery, searchColumn, true);
//   };

//   const handleClearDates = (clearType) => {
//     setFromDate("");
//     setToDate("");
//     setPage(0);
//     fetchData(0, clearType || type, searchQuery, searchColumn);
//   };

//   // Initial load and tab/status change
//   useEffect(() => {
//     if (isInitialLoad.current) {
//       dispatch(resetBookingDetails());
//       fetchData(0, type, "", "");
//       isInitialLoad.current = false;
//     } else {
//       setPage(0);
//     }
//   }, [type, complementaryStatus, instantStatus]);

//   // Handle page changes
//   useEffect(() => {
//     if (!isInitialLoad.current) {
//       fetchData(
//         page,
//         type,
//         searchQuery,
//         searchColumn,
//         fromDate || toDate,
//         pageSize
//       );
//     }
//   }, [page, pageSize]);

//   useEffect(() => {
//     const processedData = preprocessData(bookings);
//     setAllBookings(processedData);
//   }, [bookings]);

//   useEffect(() => {
//     return () => {
//       dispatch(resetBookingDetails());
//     };
//   }, []);

//   useEffect(() => {
//     return () => {
//       if (searchTimerRef.current) {
//         clearTimeout(searchTimerRef.current);
//       }
//     };
//   }, []);

//   // Resend payment effects
//   useEffect(() => {
//     if (resendPaymentSuccess) {
//       toast.success(resendPaymentData?.message, {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resendRazorpayLinkReset());
//           fetchData();
//         },
//       });

//       if (user.customer_id && resendPaymentData?.payment_url) {
//         window.location.href = resendPaymentData.payment_url;
//       }
//     }
//     if (resendPaymentError) {
//       toast.error(`Failed to send payment link`, {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resendRazorpayLinkReset());
//           fetchData();
//         },
//       });
//     }
//   }, [resendPaymentSuccess, resendPaymentError]);

//   // Update payment status effects
//   useEffect(() => {
//     if (updatePaymentSuccess) {
//       toast.success("Payment status updated successfully!", {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(updatePaymentStatusReset());
//           fetchData(page, type, searchQuery, searchColumn);
//           handleClosePaymentDialog();
//         },
//       });
//     }

//     if (updatePaymentError) {
//       toast.error(`Failed to update payment status: ${updatePaymentError}`, {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(updatePaymentStatusReset());
//         },
//       });
//     }
//   }, [updatePaymentSuccess, updatePaymentError]);

//   // Update booking status effects
//   useEffect(() => {
//     if (updateBookingSuccess) {
//       toast.success("Booking status updated successfully!", {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(updateBookingStatusReset());
//           fetchData(page, type, searchQuery, searchColumn);
//           handleCloseBookingStatusDialog();
//         },
//       });
//     }

//     if (updateBookingError) {
//       toast.error(`Failed to update Booking status: ${updateBookingError}`, {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(updateBookingStatusReset());
//         },
//       });
//     }
//   }, [updateBookingSuccess, updateBookingError]);

//   // Delete success effect
//   useEffect(() => {
//     if (deleteSuccess === "Your bookingservice cancelled") {
//       toast.success("Your bookingservice cancelled", {
//         position: "top-center",
//         autoClose: 3000,
//         onClose: () => {
//           dispatch(resetBookingDetails());
//           fetchData(page, type, searchQuery, searchColumn, fromDate || toDate);
//         },
//       });
//     }
//   }, [deleteSuccess]);

//   // Preprocess data
//   const preprocessData = (data) => {
//     if (!data || !Array.isArray(data) || data.length === 0) {
//       return [];
//     }

//     return data.map((item, index) => {
//       const bookingUpdateLogs = Array.isArray(item?.bookingUpdateLogs)
//         ? item.bookingUpdateLogs
//         : item?.bookingUpdateLogs
//         ? [item.bookingUpdateLogs]
//         : [];

//       const latestLog =
//         bookingUpdateLogs.length > 0 ? bookingUpdateLogs[0] : null;
//       const bookingDetail = item.BookingDetail || {};
//       const billingAddress = item.BillingAddress || {};
//       const customerContact = item?.Customer?.phone || {};
//       const service = item.Service?.type_of_service || {};
//       const order = item.Order || {};
//       const numberOfAdults = bookingDetail.number_of_adults || 0;
//       const numberOfChildren = bookingDetail.number_of_child || 0;
//       const numberOfInfants = bookingDetail.number_of_infant || 0;
//       const totalPassengers =
//         numberOfAdults + numberOfChildren + numberOfInfants;
//       const bookedUser = bookingDetail["BookedUser"] || {};

//       let bookedUserName = "-";
//       const user_type = bookedUser?.user_type || 0;

//       if (user_type === 3 && bookedUser?.Customer) {
//         bookedUserName = bookedUser?.Customer?.full_name;
//       } else if (user_type === 2 && bookedUser?.Vendor) {
//         bookedUserName = bookedUser?.Vendor?.full_name;
//       } else if (user_type === 4 && bookedUser?.Staff) {
//         bookedUserName = bookedUser?.Staff?.full_name;
//       } else {
//         bookedUserName = `${bookedUser?.first_name || ""} ${
//           bookedUser?.last_name || ""
//         }`.trim();
//       }

//       return {
//         id: item.id || `booking-${index}`,
//         is_mobile: item?.is_mobile,
//         booking_number: item.id || "-",
//         booking_serial_no: item.booking_serial_no || "",
//         date_of_booking: item.created_at ? item.created_at : "-",
//         booked_user_name: bookedUserName,
//         promo_code: item?.Promocode?.discount_code || "-",
//         booked_for: item?.bookingFamilies?.[0]?.familyMember?.first_name || "-",
//         pnr_number: item?.pnr_number || "-",
//         airport_name: item?.Airport?.name || "-",
//         airport_type: item?.Airport?.airport_type || "-",
//         first_name: billingAddress.first_name || "-",
//         last_name: billingAddress.last_name || "-",
//         company_name: billingAddress.company_name || "-",
//         number_of_adults: numberOfAdults || "-",
//         number_of_child: numberOfChildren || "-",
//         number_of_infant: numberOfInfants || "-",
//         total_passenger: totalPassengers,
//         service: item.Service?.services || order.service || "-",
//         service_type_label:
//           { 1: "Arrival", 2: "Departure", 3: "Transit" }[item.service_type] ||
//           "-",
//         service_types: service,
//         notes: bookingDetail.notes || "-",
//         datetime_of_arrival:
//           bookingDetail?.date_of_arrival !== "2000-01-01"
//             ? bookingDetail?.time_of_arrival
//               ? `${bookingDetail?.date_of_arrival} ${bookingDetail?.time_of_arrival}`
//               : `${bookingDetail?.date_of_arrival}`
//             : "-",
//         datetime_of_departure:
//           bookingDetail?.date_of_departure !== "2000-01-01"
//             ? bookingDetail?.time_of_departure
//               ? `${bookingDetail?.date_of_departure} ${bookingDetail?.time_of_departure}`
//               : `${bookingDetail?.date_of_departure}`
//             : "-",
//         arrival_city:
//           item?.Service?.type_of_name === "arrival"
//             ? item.Airport?.name
//             : bookingDetail.arrival_from_city || "-",
//         arrival_airline: bookingDetail.arrival_airlines || "-",
//         arrival_flight_number: bookingDetail.arrival_flight_number || "-",
//         arival_pnr_by_customer: item?.arival_pnr_by_customer || "-",
//         departure_city:
//           item?.Service?.type_of_name === "departure"
//             ? item.Airport?.name
//             : bookingDetail.departure_from_city || "-",
//         departure_airline: bookingDetail.departure_airlines || "-",
//         departure_flight_number: bookingDetail.departure_flight_number || "-",
//         departure_pnr_by_customer: item?.departure_pnr_by_customer || "-",
//         payment_status: item?.payment_status || 0,
//         approove_status: item.approove_status,
//         booked_type: item.booked_type,
//         user_type: user_type,
//         contact: customerContact,
//         emergency_contact: billingAddress?.emergency_contact,
//         staff_update_status: latestLog ? latestLog.staff_update_status : null,
//         booking_status_update_by: latestLog?.Staff?.full_name || "-",
//         customer_id: item?.customer_id,
//         razorpay_order_id: item?.razorpay_order_id || item?.pnr_number,
//       };
//     });
//   };

//   const handleView = (booking) => {
    
//     const bookingId = booking?.booking_number;
   
//     const state = {
//       tab: type,
//       page: page,
//       complementaryStatus: complementaryStatus,
//       instantStatus: instantStatus,
//       searchQuery: immediateSearchQueryRef.current,
//     };

//     if (permissions?.bookings?.view || user?.role === "Admin") {
//       navigate(VIEW_BOOKINGS.replace(":bookingId", bookingId), { state });
//     } else if (user?.role === "Vendor") {
//       navigate(VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId), {
//         state,
//       });
//     } else if (user?.role === "Customer") {
//       navigate(CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId), {
//         state,
//       });
//     }
//   };

//   // Edit handler
//   const handleEdit = (booking) => {
//     const bookingId = booking?.booking_number;
    
//     const state = {
//       bookingData: booking,
//       tabEdit: type,
//       page: page,  // Use the same key 'page' for consistency
//       complementaryStatus: complementaryStatus,
//       instantStatus: instantStatus,
//       searchQuery: searchQuery,
//     };

//     if (permissions?.bookings?.edit && user?.role === "Staff") {
//       navigate(EDIT_BOOKINGS.replace(":bookingId", bookingId), { state });
//     }
//     if (user?.role === "Admin") {
//       navigate(EDIT_BOOKINGS.replace(":bookingId", bookingId), { state });
//     }
//     if (user?.role === "Vendor") {
//       navigate(VENDOR_EDIT_BOOKINGS.replace(":bookingId", bookingId), {
//         state,
//       });
//     }
//   };

//   // Resend payment helpers
//   const isFutureDate = (dateStr) => {
//     if (!dateStr || dateStr.trim().toLowerCase().includes("null")) return false;
//     const date = new Date(dateStr.trim());
//     return !isNaN(date.getTime()) && date.getTime() > new Date().getTime();
//   };

//   const shouldShowResendPaymentButton = (item) => {
//     const {
//       payment_status,
//       booked_type,
//       datetime_of_arrival,
//       datetime_of_departure,
//     } = item;
//     const isFutureArrivalOrDeparture =
//       isFutureDate(datetime_of_arrival) || isFutureDate(datetime_of_departure);
//     return (
//       payment_status !== 1 && booked_type !== 2 && isFutureArrivalOrDeparture
//     );
//   };

//   const handleResendPayment = (booking) => {
//     const payload = {
//       customer_id: booking.customer_id || user.customer_id,
//       razorpay_order_id: booking.razorpay_order_id,
//     };
//     dispatch(resendRazorpayLinkRequest(payload));
//   };

//   // Delete handlers
//   const handleOpenPopup = (booking) => {
//     setBookingToDelete(booking);
//     setOpen(true);
//   };

//   const handleClosePopup = () => {
//     setBookingToDelete(null);
//     setOpen(false);
//     setCancelReason("");
//   };

//   const handleConfirmDelete = () => {
//     if (bookingToDelete) {
//       const bookingId = bookingToDelete.booking_number;
//       dispatch(deleteBookingRequest({ bookingId, cancel_notes: cancelReason }));
//     }
//     handleClosePopup();
//   };

//   // Tab change handler
//   const handleTabChange = (event, newType) => {
//     setType(newType);
//     setPage(0);
//     handleClearDates(newType);

//     if (newType !== 4) {
//       setComplementaryStatus(2);
//     }
//     if (newType !== 5) {
//       setInstantStatus(2);
//     }
//   };


//   // Payment update handlers
//   const handleOpenPaymentUpdate = (booking) => {
//     setSelectedBooking(booking);
//     setPaymentStatus(String(booking.payment_status || "1"));
//     setReferenceNumber("");
//     setUpdatePaymentDialogOpen(true);
//   };

//   const handleClosePaymentDialog = () => {
//     setUpdatePaymentDialogOpen(false);
//     setSelectedBooking(null);
//     setReferenceNumber("");
//   };

//   const handleUpdatePaymentStatus = () => {
//     if (!selectedBooking) return;

//     const payload = {
//       booking_id: selectedBooking.booking_number,
//       payment_status: paymentStatus,
//       payment_refrence_number: referenceNumber,
//     };

//     dispatch(updatePaymentStatusRequest(payload));
//   };

//   // Booking status update handlers
//   const handleOpenBookingStatusUpdate = (booking) => {
//     setSelectedBooking(booking);
//     setBookingStatus(String(booking.staff_update_status || "1"));
//     setUpdateBookingDialogOpen(true);
//   };

//   const handleCloseBookingStatusDialog = () => {
//     setUpdateBookingDialogOpen(false);
//     setSelectedBooking(null);
//   };

//   const handleUpdateBookingStatus = () => {
//     if (!selectedBooking) return;

//     const payload = {
//       booking_id: selectedBooking.booking_number,
//       staff_update_status: bookingStatus,
//     };

//     dispatch(updateBookingStatusRequest(payload));
//   };

//   // Individual export handler
//   const handleIndividualExport = (booking) => {
//     try {
//       const serviceTypeLabel = (booking.service_type_label || "").toLowerCase();
//       const serviceMode = (booking.service_mode || "").toLowerCase();
//       const service = (booking.service || "").toLowerCase();

//       const isTransit =
//         serviceTypeLabel.includes("transit") ||
//         serviceMode.includes("transit") ||
//         service.includes("transit");

//       const isDepartureByLabel =
//         serviceTypeLabel.includes("departure") ||
//         serviceMode.includes("departure") ||
//         service.includes("departure");

//       const isDepartureByData =
//         booking.datetime_of_departure &&
//         booking.datetime_of_departure !== "-" &&
//         booking.datetime_of_departure !== null;

//       const isArrivalByLabel =
//         serviceTypeLabel.includes("arrival") ||
//         serviceMode.includes("arrival") ||
//         service.includes("arrival");

//       const isArrivalByData =
//         booking.datetime_of_arrival &&
//         booking.datetime_of_arrival !== "-" &&
//         booking.datetime_of_arrival !== null;

//       let isDeparture = false;
//       let isArrival = false;

//       if (isTransit) {
//         isArrival = true;
//         isDeparture = true;
//       } else if (isDepartureByLabel) {
//         isDeparture = true;
//       } else if (isArrivalByLabel) {
//         isArrival = true;
//       } else if (isDepartureByData && !isArrivalByData) {
//         isDeparture = true;
//       } else if (isArrivalByData && !isDepartureByData) {
//         isArrival = true;
//       } else if (isArrivalByData) {
//         isArrival = true;
//       }

//       const getAirportCity = () => {
//         if (isTransit) {
//           const arrivalCity = booking.arrival_city || "";
//           const departureCity = booking.departure_city || "";

//           if (arrivalCity && departureCity) {
//             return `Arrival: ${arrivalCity} | Departure: ${departureCity}`;
//           } else if (arrivalCity) {
//             return `Arrival: ${arrivalCity}`;
//           } else if (departureCity) {
//             return `Departure: ${departureCity}`;
//           }
//           return booking.airport_name || "-";
//         } else if (isDeparture && booking.departure_city) {
//           return booking.departure_city;
//         } else if (isArrival && booking.arrival_city) {
//           return booking.arrival_city;
//         }
//         return (
//           booking.departure_city ||
//           booking.arrival_city ||
//           booking.airport_name ||
//           "-"
//         );
//       };

//       const getServiceDate = () => {
//         const cleanDate = (dateTime) => {
//           if (!dateTime || dateTime === "-") return null;
//           const dateStr = formatDateWithAmPm(dateTime).split(" ")[0];
//           return dateStr.replace(/[,\s]+$/, "").trim();
//         };

//         if (isTransit) {
//           const arrivalDate = cleanDate(booking.datetime_of_arrival);
//           if (arrivalDate) return arrivalDate;
//           const departureDate = cleanDate(booking.datetime_of_departure);
//           if (departureDate) return departureDate;
//         } else if (isDeparture) {
//           const departureDate = cleanDate(booking.datetime_of_departure);
//           if (departureDate) return departureDate;
//         } else if (isArrival) {
//           const arrivalDate = cleanDate(booking.datetime_of_arrival);
//           if (arrivalDate) return arrivalDate;
//         }

//         const departureDate = cleanDate(booking.datetime_of_departure);
//         if (departureDate) return departureDate;
//         const arrivalDate = cleanDate(booking.datetime_of_arrival);
//         if (arrivalDate) return arrivalDate;

//         return "-";
//       };
//       const getFlightTime = () => {
//         if (isTransit) {
//           // For transit, show both arrival and departure times
//           let arrivalTime = "";
//           let departureTime = "";

//           if (
//             booking.datetime_of_arrival &&
//             booking.datetime_of_arrival !== "-"
//           ) {
//             arrivalTime = formatDateWithAmPm(booking.datetime_of_arrival)
//               .split(" ")
//               .slice(1)
//               .join(" ");
//           }

//           if (
//             booking.datetime_of_departure &&
//             booking.datetime_of_departure !== "-"
//           ) {
//             departureTime = formatDateWithAmPm(booking.datetime_of_departure)
//               .split(" ")
//               .slice(1)
//               .join(" ");
//           }

//           if (arrivalTime && departureTime) {
//             return `Arrival: ${arrivalTime} | Departure: ${departureTime}`;
//           } else if (arrivalTime) {
//             return `Arrival: ${arrivalTime}`;
//           } else if (departureTime) {
//             return `Departure: ${departureTime}`;
//           }
//           return "-";
//         } else if (isDeparture) {
//           if (
//             booking.datetime_of_departure &&
//             booking.datetime_of_departure !== "-"
//           ) {
//             return formatDateWithAmPm(booking.datetime_of_departure)
//               .split(" ")
//               .slice(1)
//               .join(" ");
//           }
//         } else if (isArrival) {
//           if (
//             booking.datetime_of_arrival &&
//             booking.datetime_of_arrival !== "-"
//           ) {
//             return formatDateWithAmPm(booking.datetime_of_arrival)
//               .split(" ")
//               .slice(1)
//               .join(" ");
//           }
//         }
//         // Fallback: try both
//         if (
//           booking.datetime_of_departure &&
//           booking.datetime_of_departure !== "-"
//         ) {
//           return formatDateWithAmPm(booking.datetime_of_departure)
//             .split(" ")
//             .slice(1)
//             .join(" ");
//         }
//         if (
//           booking.datetime_of_arrival &&
//           booking.datetime_of_arrival !== "-"
//         ) {
//           return formatDateWithAmPm(booking.datetime_of_arrival)
//             .split(" ")
//             .slice(1)
//             .join(" ");
//         }
//         return "-";
//       };

//       const getAirline = () => {
//         if (isTransit) {
//           const arrivalAirline = booking.arrival_airline || "";
//           const departureAirline = booking.departure_airline || "";

//           if (arrivalAirline && departureAirline) {
//             return `Arrival: ${arrivalAirline} | Departure: ${departureAirline}`;
//           } else if (arrivalAirline) {
//             return `Arrival: ${arrivalAirline}`;
//           } else if (departureAirline) {
//             return `Departure: ${departureAirline}`;
//           }
//           return "-";
//         } else if (isDeparture && booking.departure_airline) {
//           return booking.departure_airline;
//         } else if (isArrival && booking.arrival_airline) {
//           return booking.arrival_airline;
//         }
//         return booking.departure_airline || booking.arrival_airline || "-";
//       };

//       const getFlightNumber = () => {
//         if (isTransit) {
//           const arrivalFlightNumber = booking.arrival_flight_number || "";
//           const departureFlightNumber = booking.departure_flight_number || "";

//           if (arrivalFlightNumber && departureFlightNumber) {
//             return `Arrival: ${arrivalFlightNumber} | Departure: ${departureFlightNumber}`;
//           } else if (arrivalFlightNumber) {
//             return `Arrival: ${arrivalFlightNumber}`;
//           } else if (departureFlightNumber) {
//             return `Departure: ${departureFlightNumber}`;
//           }
//           return "-";
//         } else if (isDeparture && booking.departure_flight_number) {
//           return booking.departure_flight_number;
//         } else if (isArrival && booking.arrival_flight_number) {
//           return booking.arrival_flight_number;
//         }
//         return (
//           booking.departure_flight_number ||
//           booking.arrival_flight_number ||
//           "-"
//         );
//       };

//       const getPNR = () => {
//         if (isTransit) {
//           const arrivalPNR = booking.arival_pnr_by_customer || "";
//           const departurePNR = booking.departure_pnr_by_customer || "";
//           const generalPNR = booking.pnr_number || "";

//           if (arrivalPNR && departurePNR) {
//             return `Arrival: ${arrivalPNR} | Departure: ${departurePNR}`;
//           } else if (arrivalPNR) {
//             return `Arrival: ${arrivalPNR}`;
//           } else if (departurePNR) {
//             return `Departure: ${departurePNR}`;
//           } else if (generalPNR) {
//             return generalPNR;
//           }
//           return "-";
//         } else if (isDeparture && booking.departure_pnr_by_customer) {
//           return booking.departure_pnr_by_customer;
//         } else if (isArrival && booking.arival_pnr_by_customer) {
//           return booking.arival_pnr_by_customer;
//         }
//         return (
//           booking.departure_pnr_by_customer ||
//           booking.arival_pnr_by_customer ||
//           booking.pnr_number ||
//           "-"
//         );
//       };

//       const csvRows = [
//         ["Guest Name", `\t${booking.booked_for || "-"}`],
//         ["Placard Guest Name", `\t${booking.booked_for || "-"}`],
//         [
//           "Guest Contact No.",
//           (booking?.contact || "-") +
//             " / " +
//             (booking?.emergency_contact || "-"),
//         ],
//         ["No. of Pax", `\t${booking.total_passenger || "1"}`],
//         ["Service Date", `\t${getServiceDate()}`],
//         ["Airport", `\t${getAirportCity() || "-"}`],
//         ["Terminal", `\t${booking.service_types || "-"}`],
//         ["Service Type", `\t${booking.service || "-"}`],
//         ["Service Mode", `\t${booking.service_type_label || "-"}`],
//         ["Airline", `\t${getAirline()}`],
//         ["Flight Number", `\t${getFlightNumber()}`],
//         ["Flight Time", `\t${getFlightTime()}`],
//         ["PNR No.", `\t${getPNR()}`],
//         ["Remarks", `\t${booking.notes || "-"}`],
//       ];

//       const csvContent = csvRows
//         .map((row) =>
//           row
//             .map((field) => {
//               let stringField = String(field || "");
//               if (
//                 stringField.includes(",") ||
//                 stringField.includes('"') ||
//                 stringField.includes("\n") ||
//                 stringField.includes("\t")
//               ) {
//                 return `"${stringField.replace(/"/g, '""')}"`;
//               }
//               return stringField;
//             })
//             .join(",")
//         )
//         .join("\n");

//       const BOM = "\uFEFF";
//       const csvWithBOM = BOM + csvContent;
//       const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
//       const fileName = `booking_${booking.booking_serial_no}.csv`;
//       saveAs(blob, fileName);
//     } catch (error) {
//       toast.error("Failed to export booking details", {
//         position: "top-center",
//         autoClose: 3000,
//       });
//     }
//   };

//   // Bulk export handler
//   const handleExport = () => {
//     let apiParams = {
//       pagination_required: false,
//     };
//     if (fromDate) apiParams.from_date = fromDate;
//     if (toDate) apiParams.to_date = toDate;

//     if (type === 0) {
//       apiParams = {
//         ...apiParams,
//         search: searchQuery || "",
//         search_by: searchColumn || "",
//       };
//     } else if (type === 4) {
//       apiParams = {
//         ...apiParams,
//         approove_status: complementaryStatus,
//         booked_type: 2,
//         currentDate,
//         search: searchQuery || "",
//         search_by: searchColumn || "",
//       };
//     } else if (type === 5) {
//       let instantBookingType;
//       switch (instantStatus) {
//         case 1:
//           instantBookingType = "previous";
//           break;
//         case 2:
//           instantBookingType = "upcoming";
//           break;
//         case 3:
//           instantBookingType = "cancelled";
//           break;
//         default:
//           instantBookingType = "upcoming";
//       }

//       apiParams = {
//         ...apiParams,
//         type: instantBookingType,
//         booked_type: 3,
//         currentDate,
//         search: searchQuery || "",
//         search_by: searchColumn || "",
//       };
//     } else {
//       apiParams = {
//         ...apiParams,
//         type: type === 2 ? "upcoming" : type === 1 ? "previous" : "cancelled",
//         booked_type: booked_type,
//         currentDate,
//         search: searchQuery || "",
//         search_by: searchColumn || "",
//       };
//     }

//     let apiCall;

//     if (user.role === "Customer" || user.role === "Vendor") {
//       apiCall = axiosInstance.get("/bookservice/bookinggetbycustomer", {
//         params: {
//           ...apiParams,
//           customer_id: user.customer_id || "",
//           vendor_id: user.vendor_id || "",
//           booked_type: "all",
//         },
//       });
//     } else {
//       let endpoint;
//       if (type === 0) {
//         endpoint = "bookservice/servicebookingalldata";
//       } else if (type === 4) {
//         endpoint = "bookservice/complementrybookingservice";
//       } else if (type === 5) {
//         endpoint = "bookservice/list";
//       } else {
//         endpoint = "/bookservice/list";
//       }

//       apiCall = axiosInstance.get(endpoint, { params: apiParams });
//     }

//     apiCall
//       .then((response) => {
//         let bookingsData = response?.data?.data || [];
//         const processedData = preprocessData(bookingsData);

//         const csvHeaders = [
//           "Booking Number",
//           "Booking Date",
//           "Booked User Name",
//           "Booked For",
//           "Airport Name",
//           "Airport Type",
//           "First Name",
//           "Last Name",
//           "Company Name",
//           "No Of Adult",
//           "No Of Child",
//           "No Of Infant",
//           "Total Passenger",
//           "Service",
//           "Service Type",
//           "Notes",
//           "Arrival Date/Time",
//           "Arrival City",
//           "Arrival Airline",
//           "Arrival Flight Number",
//           "Arrival PNR By Customer",
//           "Departure Date/Time",
//           "Departure City",
//           "Departure Airline",
//           "Departure Flight Number",
//           "Departure PNR By Customer",
//           "Payment Reference Number",
//           "Payment Status",
//           "Approval Status",
//           "Booked Type",
//         ];

//         const csvRows = processedData.map((booking) => {
//           const escapeCsvField = (field) => {
//             if (field === null || field === undefined) return '""';
//             const stringField = String(field || "-");
//             if (
//               stringField.includes(",") ||
//               stringField.includes('"') ||
//               stringField.includes("\n")
//             ) {
//               return `"${stringField.replace(/"/g, '""')}"`;
//             }
//             return stringField;
//           };

//           const getApprovalStatusText = (statusCode) => {
//             if (statusCode === 1 || statusCode === "1") return "Approved";
//             if (statusCode === 2 || statusCode === "2") return "Pending";
//             if (statusCode === 3 || statusCode === "3") return "Rejected";
//             return statusCode || "";
//           };

//           const getPaymentStatusText = (statusCode, bookedType) => {
//             if (statusCode === 1) return "Completed";
//             if (statusCode === 0 && bookedType === 2)
//               return "Free (Complementary)";
//             if (statusCode === 0) return "Pending";
//             if (statusCode === 2) return "Failed";
//             if (statusCode === 3) return "Refunded";
//             return "Aborted";
//           };

//           const getBookedTypeLabel = (typeCode) => {
//             switch (typeCode) {
//               case 1:
//                 return "Regular";
//               case 2:
//                 return "Complementary";
//               case 3:
//                 return "Instant Booking";
//               default:
//                 return typeCode || "";
//             }
//           };

//           const approvalStatus = booking.approove_status;
//           const approvalStatusText = getApprovalStatusText(approvalStatus);
//           const paymentStatusText = getPaymentStatusText(
//             booking.payment_status,
//             booking.booked_type
//           );

//           return [
//             escapeCsvField(booking.booking_serial_no),
//             escapeCsvField(formatDateWithAmPm(booking.date_of_booking)),
//             escapeCsvField(booking.booked_user_name),
//             escapeCsvField(booking.booked_for),
//             escapeCsvField(booking.airport_name),
//             escapeCsvField(booking.airport_type),
//             escapeCsvField(booking.first_name),
//             escapeCsvField(booking.last_name),
//             escapeCsvField(booking.company_name),
//             escapeCsvField(booking.number_of_adults),
//             escapeCsvField(booking.number_of_child),
//             escapeCsvField(booking.number_of_infant),
//             escapeCsvField(booking.total_passenger),
//             escapeCsvField(booking.service),
//             escapeCsvField(booking.service_type_label),
//             escapeCsvField(booking.notes),
//             escapeCsvField(formatDateWithAmPm(booking.datetime_of_arrival)),
//             escapeCsvField(booking.arrival_city),
//             escapeCsvField(booking.arrival_airline),
//             escapeCsvField(booking.arrival_flight_number),
//             escapeCsvField(booking.arival_pnr_by_customer),
//             escapeCsvField(formatDateWithAmPm(booking.datetime_of_departure)),
//             escapeCsvField(booking.departure_city),
//             escapeCsvField(booking.departure_airline),
//             escapeCsvField(booking.departure_flight_number),
//             escapeCsvField(booking.departure_pnr_by_customer),
//             escapeCsvField(booking.pnr_number),
//             escapeCsvField(paymentStatusText),
//             escapeCsvField(approvalStatusText),
//             escapeCsvField(getBookedTypeLabel(booking.booked_type)),
//           ].join(",");
//         });

//         const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
//         const blob = new Blob([csvContent], {
//           type: "text/csv;charset=utf-8;",
//         });
//         saveAs(blob, `bookings_${new Date().toISOString().split("T")[0]}.csv`);
//       })
//       .catch((error) => {
//         toast.error("Failed to export bookings", {
//           position: "top-center",
//           autoClose: 3000,
//         });
//       });
//   };

//   // Action button render functions
//   const renderCustomViewButton = (item) =>
//     (user?.user_type !== 1 && user?.user_type !== 2 && user?.user_type !== 3
//       ? permissions?.bookings?.view ||
//         user?.user_type === 1 ||
//         user?.user_type === 2
//       : user?.user_type === 1 ||
//         user?.user_type === 2 ||
//         user?.user_type === 3) && (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleView(item)}
//         className="grey-button"
//       >
//         VIEW
//       </Button>
//     );

//   const renderCustomEditButton = (item) => {
//     if (type === 3 || type === 1) return null;

//     const checkFutureDate = (dateString) => {
//       if (!dateString || dateString === "-" || dateString === "2000-01-01")
//         return false;
//       const datePart = dateString.trim().split(" ")[0];
//       const itemDate = new Date(datePart);
//       const today = new Date();
//       today.setHours(0, 0, 0, 0);
//       itemDate.setHours(0, 0, 0, 0);
//       return itemDate > today;
//     };

//     const arrivalIsFuture = checkFutureDate(item.datetime_of_arrival);
//     const departureIsFuture = checkFutureDate(item.datetime_of_departure);
//     const canEdit = arrivalIsFuture || departureIsFuture;

//     const hasPermission =
//       user?.user_type !== 1 && user?.user_type !== 2
//         ? permissions?.bookings?.edit ||
//           user?.user_type === 1 ||
//           user?.user_type === 2
//         : user?.user_type === 1 || user?.user_type === 2;

//     return (
//       hasPermission &&
//       canEdit && (
//         <Button
//           variant="outlined"
//           size="small"
//           onClick={() => handleEdit(item)}
//           className="orange-button"
//         >
//           EDIT
//         </Button>
//       )
//     );
//   };

//   const renderCustomDeleteButton = (item) => {
//     if (type === 3 || type === 1) return null;
//     return (
//       (user?.user_type !== 1 && user?.user_type !== 2
//         ? permissions?.bookings?.edit ||
//           user?.user_type === 1 ||
//           user?.user_type === 2
//         : user?.user_type === 1) && (
//         <Button
//           variant="outlined"
//           size="small"
//           onClick={() => handleOpenPopup(item)}
//           className="grey-button"
//         >
//           CANCEL
//         </Button>
//       )
//     );
//   };

//   const renderResendPaymentButton = (item) => {
//     if (!shouldShowResendPaymentButton(item)) return null;
//     return (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleResendPayment(item)}
//         className="orange-button"
//         disabled={resendPaymentLoading}
//       >
//         {resendPaymentLoading ? "SENDING..." : "RETRY"}
//       </Button>
//     );
//   };

//   const renderIndividualExportButton = (item) => {
//     if (user?.role !== "Admin" && user?.role !== "Staff") return null;
//     return (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleIndividualExport(item)}
//         className="orange-button"
//       >
//         EXPORT
//       </Button>
//     );
//   };

//   const renderPaymentUpdateButton = (item) =>
//     (["Admin"].includes(user?.role) ||
//       ["Manager"].includes(user?.role_name)) && (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleOpenPaymentUpdate(item)}
//         className="grey-button"
//         sx={{ width: "130px" }}
//       >
//         UPDATE STATUS
//       </Button>
//     );

//   const renderBookingUpdateButton = (item) =>
//     (["Admin"].includes(user?.role) ||
//       ["Manager"].includes(user?.role_name)) && (
//       <Button
//         variant="outlined"
//         size="small"
//         onClick={() => handleOpenBookingStatusUpdate(item)}
//         className="orange-button"
//         sx={{ width: "150px" }}
//       >
//         BOOKING STATUS
//       </Button>
//     );

//   const ActionsCell = ({ params }) => {
//     const [anchorEl, setAnchorEl] = useState(null);
//     const open = Boolean(anchorEl);

//     const handleClick = (event) => {
//       event.stopPropagation(); // Prevent event from bubbling up
//       setAnchorEl(event.currentTarget);
//     };
//     const handleClose = () => setAnchorEl(null);


//     const viewButton = renderCustomViewButton(params.row);
//     const editButton = renderCustomEditButton(params.row);
//     const cancelButton = renderCustomDeleteButton(params.row);
//     const retryButton = renderResendPaymentButton(params.row);
//     const exportButton = renderIndividualExportButton(params.row);
//     const paymentUpdateButton = renderPaymentUpdateButton(params.row);
//     const bookingStatusButton = renderBookingUpdateButton(params.row);

//     const primaryActions = [viewButton, editButton].filter(Boolean);
//     const menuActions = [
//       cancelButton,
//       retryButton,
//       exportButton,
//       paymentUpdateButton,
//       bookingStatusButton,
//     ].filter(Boolean);

//     return (
//       <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
//         {primaryActions}
//         {menuActions.length > 0 && (
//           <>
//             <IconButton
//               size="small"
//               onClick={handleClick}
//               sx={{
//                 border: "1px solid #ccc",
//                 borderRadius: "4px",
//                 padding: "4px 8px",
//               }}
//             >
//               <MoreVertIcon fontSize="small" />
//             </IconButton>

//             <Menu 
//               anchorEl={anchorEl} 
//               open={open} 
//               onClose={handleClose}
//               onClick={(e) => e.stopPropagation()}
//               disableRestoreFocus
//               componentsProps={{
//                 paper: {
//                   onClick: (e) => e.stopPropagation()
//                 }
//               }}
//             >
//               {cancelButton && (
//                 <MenuItem
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleClose();
//                     handleOpenPopup(params.row);
//                   }}
//                 >
//                   Cancel Booking
//                 </MenuItem>
//               )}

//               {retryButton && (
//                 <MenuItem
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleClose();
//                     handleResendPayment(params.row);
//                   }}
//                 >
//                   Retry Payment
//                 </MenuItem>
//               )}

//               {exportButton && (
//                 <MenuItem
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleClose();
//                     handleIndividualExport(params.row);
//                   }}
//                 >
//                   Export
//                 </MenuItem>
//               )}

//               {paymentUpdateButton && (
//                 <MenuItem
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleClose();
//                     handleOpenPaymentUpdate(params.row);
//                   }}
//                 >
//                   Update Payment Status
//                 </MenuItem>
//               )}

//               {bookingStatusButton && (
//                 <MenuItem
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     handleClose();
//                     handleOpenBookingStatusUpdate(params.row);
//                   }}
//                 >
//                   Update Booking Status
//                 </MenuItem>
//               )}
//             </Menu>
//           </>
//         )}
//       </Box>
//     );
//   };

//   // DataGrid columns
//   const columns = useMemo(() => {
//     const baseColumns = [
//       {
//         field: "booking_serial_no",
//         headerName: "Booking Number",
//         width: 180,
//         renderCell: (params) => {
//           const sourceBadge =
//             params.row.is_mobile == 0
//               ? { label: "Mobile", color: "rgb(251,207,154)" }
//               : { label: "Web", color: "rgb(52,207,229)" };

//           return (
//             <Box
//               sx={{
//                 backgroundColor: sourceBadge?.color,
//                 borderRadius: 3,
//                 display: "inline-block",
//                 cursor: "pointer",
//               }}
//               onClick={() => handleView(params.row)}
//             >
//               <Typography
//                 sx={{
//                   color: "white",
//                   padding: 1,
//                   textDecoration: "none",
//                   borderRadius: 3,
//                   fontSize: "0.875rem",
//                 }}
//               >
//                 {params.value}
//               </Typography>
//             </Box>
//           );
//         },
//       },
//       {
//         field: "date_of_booking",
//         headerName: "Booking Date",
//         width: 180,
//         renderCell: (params) => {
//           const value = params?.row?.date_of_booking;
//           return value ? formatDateWithAmPm(value) : "-";
//         },
//       },
//       {
//         field: "booked_user_name",
//         headerName: "Booked By",
//         width: 200,
//         renderCell: (params) => {
//           if (params.row.user_type === 2) {
//             return (
//               <span className="badge vendor-badge">
//                 {params.value} (Vendor)
//               </span>
//             );
//           } else if (params.row.user_type === 3) {
//             return (
//               <span className="badge customer-badge">
//                 {params.value} (Customer)
//               </span>
//             );
//           }
//           return params.value;
//         },
//       },
//       { field: "booked_for", headerName: "Booked For", width: 150 },
//       { field: "number_of_adults", headerName: "No of Adults", width: 120 },
//       { field: "number_of_child", headerName: "No of Children", width: 130 },
//       { field: "number_of_infant", headerName: "No of Infants", width: 130 },
//       { field: "total_passenger", headerName: "Total Passengers", width: 150 },
//       { field: "service", headerName: "Service", width: 150 },
//       { field: "service_type_label", headerName: "Service Type", width: 150 },
//       {
//         field: "datetime_of_arrival",
//         headerName: "Arrival Date/Time",
//         width: 180,
//         renderCell: (params) => {
//           const value = params?.row?.datetime_of_arrival;
//           return value ? formatDateWithAmPmBooking(value) : "-";
//         },
//       },
//       { field: "arrival_city", headerName: "Arrival City", width: 150 },
//       { field: "arrival_airline", headerName: "Arrival Airline", width: 150 },
//       {
//         field: "arrival_flight_number",
//         headerName: "Arrival Flight Number",
//         width: 180,
//       },
//       {
//         field: "arival_pnr_by_customer",
//         headerName: "Arrival PNR Number",
//         width: 180,
//       },
//       {
//         field: "datetime_of_departure",
//         headerName: "Departure Date/Time",
//         width: 180,
//         renderCell: (params) => {
//           const value = params?.row?.datetime_of_departure;
//           return value ? formatDateWithAmPmBooking(value) : "-";
//         },
//       },
//       { field: "departure_city", headerName: "Departure City", width: 150 },
//       {
//         field: "departure_airline",
//         headerName: "Departure Airline",
//         width: 150,
//       },
//       {
//         field: "departure_flight_number",
//         headerName: "Departure Flight Number",
//         width: 180,
//       },
//       {
//         field: "departure_pnr_by_customer",
//         headerName: "Departure PNR Number",
//         width: 180,
//       },
//       {
//         field: "pnr_number",
//         headerName: "Payment Reference Number",
//         width: 200,
//       },
//       {
//         field: "payment_status",
//         headerName: "Payment Status",
//         width: 180,
//         renderCell: (params) => (
//           <Chip
//             label={
//               params.value === 1
//                 ? "Completed"
//                 : params.value === 0 && params.row?.booked_type === 2
//                 ? "Free (Complementary)"
//                 : params.value === 0
//                 ? "Pending"
//                 : params.value === 2
//                 ? "Failed"
//                 : params.value === 3
//                 ? "Refunded"
//                 : "Aborted"
//             }
//             color={
//               params.value === 1
//                 ? "success"
//                 : params.value === 0 && params.row?.booked_type === 2
//                 ? "success"
//                 : params.value === 2
//                 ? "error"
//                 : params.value === 3
//                 ? "success"
//                 : params.value === 0
//                 ? "warning"
//                 : "error"
//             }
//             size="small"
//           />
//         ),
//       },
//       { field: "promo_code", headerName: "Promo Code", width: 150 },
//       { field: "notes", headerName: "Notes", width: 200 },
//       {
//         field: "actions",
//         headerName: "Actions",
//         width: 200,
//         sortable: false,
//         filterable: false,
//         renderCell: (params) => <ActionsCell params={params} />,
//       },
//     ];

//     if (user?.user_type !== 2 && user?.user_type !== 3) {
//       const insertIndex = baseColumns.findIndex(
//         (col) => col.field === "promo_code"
//       );
//       baseColumns.splice(
//         insertIndex,
//         0,
//         {
//           field: "staff_update_status",
//           headerName: "Booking Status",
//           width: 150,
//           renderCell: (params) => {
//             if (params.value === undefined || params.value === null) return "-";
//             const statusMap = {
//               1: { label: "Pending", color: "warning" },
//               2: { label: "Processing", color: "warning" },
//               3: { label: "Completed", color: "success" },
//               4: { label: "Cancelled", color: "error" },
//             };
//             return (
//               <Chip
//                 label={statusMap[params.value]?.label || "-"}
//                 color={statusMap[params.value]?.color || "default"}
//                 size="small"
//               />
//             );
//           },
//         },
//         {
//           field: "booking_status_update_by",
//           headerName: "Updated By",
//           width: 150,
//         }
//       );
//     }

//     return baseColumns;
//   }, [user, type, permissions]);

//   if (viewListLoading) {
//     return <Loading text="Loading Booking Details..." />;
//   }

//   return (
//     <>
//       <ToastContainer />
//       <Box className="container">
//         <Grid container spacing={5}>
//           <Grid item xs={12}>
//             <Card>
//               <CardContent>
//                 <SearchAndButtonTab
//                   title="Bookings"
//                   columns={bookingFilterHeaders}
//                   searchColumn={searchColumn}
//                   hideSearchColumnSelector={true}
//                   setSearchColumn={handleColumnChange}
//                   searchQuery={searchQuery}
//                   setSearchQuery={handleSearch}
//                   handleExport={handleExport}
//                   routeName={
//                     user.role === "Vendor"
//                       ? VENDOR_BOOKING_AIRPORT_DETAILS
//                       : user.role === "Customer"
//                       ? CUSTOMER_BOOKING_AIRPORT_DETAILS
//                       : BOOKING_AIRPORT_DETAILS
//                   }
//                   permissions={permissions}
//                   user={user}
//                 />

//                 {(user?.role === "Admin" || user?.role === "Staff") && (
//                   <Box
//                     sx={{
//                       display: "flex",
//                       gap: 2,
//                       mb: 2,
//                       alignItems: "center",
//                       flexWrap: "wrap",
//                     }}
//                   >
//                     <TextField
//                       label="From Date"
//                       type="date"
//                       value={fromDate}
//                       onChange={(e) => setFromDate(e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                       sx={{ minWidth: 180 }}
//                       inputProps={{ max: toDate || currentDate }}
//                     />
//                     <TextField
//                       label="To Date"
//                       type="date"
//                       value={toDate}
//                       onChange={(e) => setToDate(e.target.value)}
//                       InputLabelProps={{ shrink: true }}
//                       sx={{ minWidth: 180 }}
//                       inputProps={{ min: fromDate }}
//                     />
//                     <Button
//                       variant="contained"
//                       onClick={handleDateFilterSubmit}
//                       disabled={!fromDate && !toDate}
//                       className="orange-button"
//                     >
//                       Apply Dates
//                     </Button>
//                     <Button
//                       variant="outlined"
//                       onClick={() => handleClearDates()}
//                       disabled={!fromDate && !toDate}
//                       className="grey-button"
//                     >
//                       Clear Dates
//                     </Button>
//                   </Box>
//                 )}

//                 <Box
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                   }}
//                 >
//                   <Tabs
//                     value={type}
//                     onChange={handleTabChange}
//                     indicatorColor="primary"
//                     textColor="primary"
//                   >
//                     {user.role !== "Customer" && user.role !== "Vendor" && (
//                       <Tab label="All" value={0} />
//                     )}
//                     <Tab label="Upcoming" value={2} />
//                     <Tab label="Completed" value={1} />
//                     <Tab label="Cancelled" value={3} />
//                     {user.role !== "Customer" && user.role !== "Vendor" && (
//                       <Tab label="Complementary" value={4} />
//                     )}
//                     {user.role !== "Customer" && user.role !== "Vendor" && (
//                       <Tab label="Instant Booking" value={5} />
//                     )}
//                   </Tabs>
//                 </Box>

//                 {type === 4 && (
//                   <Tabs
//                     value={complementaryStatus}
//                     onChange={(event, newStatus) =>
//                       setComplementaryStatus(newStatus)
//                     }
//                     indicatorColor="primary"
//                     textColor="primary"
//                     sx={{ ml: 2 }}
//                   >
//                     <Tab label="Pending" value={2} className="tab-heights" />
//                     <Tab label="Approved" value={1} className="tab-heights" />
//                     <Tab label="Rejected" value={3} className="tab-heights" />
//                   </Tabs>
//                 )}

//                 {type === 5 && (
//                   <Tabs
//                     value={instantStatus}
//                     onChange={(event, newStatus) => setInstantStatus(newStatus)}
//                     indicatorColor="primary"
//                     textColor="primary"
//                     sx={{ ml: 2 }}
//                   >
//                     <Tab label="Upcoming" value={2} className="tab-heights" />
//                     <Tab label="Completed" value={1} className="tab-heights" />
//                     <Tab label="Cancelled" value={3} className="tab-heights" />
//                   </Tabs>
//                 )}

//                 <Box sx={{ height: 650, width: "100%", mt: 2 }}>
//                   {allBookings.length > 0 ? (
//                  <DataGrid
//   rows={allBookings}
//   columns={columns}
//   pagination
//   page={page}
//   pageSize={pageSize}
//   rowCount={totalRecord}
//   paginationMode="server"
//   loading={viewListLoading}
//   disableSelectionOnClick
//   getRowHeight={() => "auto"}
//   paginationModel={{ page: page, pageSize: pageSize }}
//   onPaginationModelChange={(params) => {
//     setPage(params.page);
//     setPageSize(params.pageSize);
//     fetchData(params.page, type, searchQuery, searchColumn, true, params.pageSize);
//   }}
//   pageSizeOptions={[10, 25, 50, 100]}
//   hideFooterPagination={true} // Hide default pagination
//   slots={{
//     footer: () => (
//       <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', padding: '16px' }}>
//         <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//           <span>Rows per page:</span>
//           <select
//             value={pageSize}
//             onChange={(e) => {
//               const newPageSize = Number(e.target.value);
//               setPageSize(newPageSize);
//               fetchData(page, type, searchQuery, searchColumn, true, newPageSize);
//             }}
//             style={{ padding: '4px', borderRadius: '4px', border: '1px solid #ccc' }}
//           >
//             {[10, 25, 50, 100].map((size) => (
//               <option key={size} value={size}>
//                 {size}
//               </option>
//             ))}
//           </select>
//           <span>
//             {page * pageSize + 1}-{Math.min((page + 1) * pageSize, totalRecord)} of {totalRecord}
//           </span>
//           <button
//             onClick={() => {
//               const newPage = Math.max(0, page - 1);
//               setPage(newPage);
//               fetchData(newPage, type, searchQuery, searchColumn, true, pageSize);
//             }}
//             disabled={page === 0}
//             style={{
//               padding: '4px 8px',
//               margin: '0 4px',
//               cursor: page === 0 ? 'not-allowed' : 'pointer',
//               opacity: page === 0 ? 0.5 : 1,
//             }}
//           >
//             &lt;
//           </button>
//           <button
//             onClick={() => {
   
//               const newPage = page + 1;
//               setPage(newPage);
//               fetchData(newPage, type, searchQuery, searchColumn, true, pageSize);
//             }}
//             disabled={(page + 1) * pageSize >= totalRecord}
//             style={{
//               padding: '4px 8px',
//               margin: '0 4px',
//               cursor: (page + 1) * pageSize >= totalRecord ? 'not-allowed' : 'pointer',
//               opacity: (page + 1) * pageSize >= totalRecord ? 0.5 : 1,
//             }}
//           >
//             &gt;
//           </button>
//         </div>
//       </div>
//     ),
//   }}
//   sx={{
//     "& .MuiDataGrid-cell": {
//       borderBottom: "1px solid #f0f0f0",
//       py: 1,
//     },
//     "& .MuiDataGrid-columnHeaders": {
//       backgroundColor: "#f5f5f5",
//       fontWeight: "bold",
//     },
//     "& .MuiDataGrid-row:hover": {
//       backgroundColor: "#f9f9f9",
//     },
//   }}
// />
              
//                   ) : (
//                     <Box textAlign="center" py={5}>
//                       <img
//                         src={nodata}
//                         alt="No Data"
//                         style={{ maxWidth: "300px", maxHeight: "300px" }}
//                       />
//                     </Box>
//                   )}
//                 </Box>
//               </CardContent>
//             </Card>
//           </Grid>
//         </Grid>

//         <Dialog open={open} onClose={handleClosePopup} maxWidth="sm" fullWidth>
//           <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
//             Confirm Cancellation
//           </DialogTitle>
//           <DialogContent sx={{ p: 3 }}>
//             <DialogContentText
//               sx={{ mb: 2, textAlign: "center", fontSize: "16px" }}
//             >
//               Are you sure you want to cancel this booking? <br />
//               <strong>Booking ID: {bookingToDelete?.booking_serial_no}</strong>
//             </DialogContentText>
//             <TextField
//               autoFocus
//               margin="dense"
//               label="Reason for Cancellation"
//               type="text"
//               name="cancelReason"
//               fullWidth
//               multiline
//               rows={4}
//               variant="outlined"
//               value={cancelReason}
//               onChange={(e) => setCancelReason(e.target.value)}
//               required
//               sx={{
//                 "& .MuiOutlinedInput-root": {
//                   borderRadius: "10px",
//                 },
//               }}
//             />
//           </DialogContent>
//           <DialogActions sx={{ justifyContent: "end", px: 3, pb: 3 }}>
//             <Button
//               size="medium"
//               onClick={handleClosePopup}
//               className="handle-back"
//               variant="outlined"
//               sx={{
//                 borderRadius: "8px",
//                 minWidth: "100px",
//               }}
//             >
//               Cancel
//             </Button>
//             <CustomButton
//               variant="contained"
//               className="handle-delete"
//               type="submit"
//               size="medium"
//               loading={deleteLoading}
//               text="Confirm Cancel"
//               onClick={handleConfirmDelete}
//               disabled={!cancelReason.trim()}
//               sx={{
//                 borderRadius: "8px",
//                 minWidth: "130px",
//                 backgroundColor: "#d32f2f",
//                 "&:hover": {
//                   backgroundColor: "#b71c1c",
//                 },
//               }}
//             />
//           </DialogActions>
//         </Dialog>

//         <PaymentStatusDialog
//           open={updatePaymentDialogOpen}
//           onClose={handleClosePaymentDialog}
//           title="Update Payment Status"
//           selectedBooking={selectedBooking}
//           handleUpdateStatus={handleUpdatePaymentStatus}
//           loading={updatePaymentLoading}
//           updateStatus={paymentStatus}
//           setUpdateStatus={setPaymentStatus}
//           setReferenceNumber={setReferenceNumber}
//         />

//         <PaymentStatusDialog
//           open={updateBookingDialogOpen}
//           onClose={handleCloseBookingStatusDialog}
//           title="Update Booking Status"
//           selectedBooking={selectedBooking}
//           handleUpdateStatus={handleUpdateBookingStatus}
//           loading={updateBookingLoading}
//           updateStatus={bookingStatus}
//           setUpdateStatus={setBookingStatus}
//         />
//       </Box>
//     </>
//   );
// };

// export default BookingList;
import React, { useEffect, useMemo, useRef, useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Pagination,
  IconButton,
  Tabs,
  Tab,
  TextField,
  Chip,
  Select,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ReusableTable from "../../component/ui/ReusableTable";
import { saveAs } from "file-saver";
import { useLocation, useNavigate } from "react-router-dom";
import "../../styles/Booking.scss";
import "../../styles/UserStyles.css";
import SearchAndButtonTab from "../../component/ui/SearchAndButtonTab";
import {
  formatDateWithAmPm,
  formatDateWithAmPmBooking,
  getStatusClass,
} from "../../Style";
import {
  BOOKING_AIRPORT_DETAILS,
  EDIT_BOOKINGS,
  VIEW_BOOKINGS,
} from "../../component/common/Routes/AppRoutes";
import { useDispatch, useSelector } from "react-redux";
import {
  VENDOR_BOOKING_AIRPORT_DETAILS,
  VENDOR_EDIT_BOOKINGS,
  VENDOR_VIEW_BOOKINGS,
} from "../../component/common/Routes/VendorRoutes";
import {
  CUSTOMER_BOOKING_AIRPORT_DETAILS,
  CUSTOMER_VIEW_BOOKINGS,
} from "../../component/common/Routes/CustomerRoutes";
import {
  fetchBookingsRequest,
  deleteBookingRequest,
  fetchCustomerBookingsRequest,
  resetBookingDetails,
  fetchComplementaryBookingsRequest,
  fetchInstantBookingsRequest,
  getAllBookingsRequest,
  fetchAllBookingRequest,
  resendRazorpayLinkRequest,
  resendRazorpayLinkReset,
  updatePaymentStatusReset,
  updatePaymentStatusRequest,
  updateBookingStatusReset,
  updateBookingStatusRequest,
} from "../../redux/Bookings/BookingAction";

import CustomButton from "../../component/ui/FormFields/Button";
import { toast, ToastContainer } from "react-toastify";
import Loading from "../../component/ui/Loading";
import nodata from "../../assets/nodata.jpg";
import axiosInstance from "../../redux/instance/AxiosInstance";
import PaymentStatusDialog from "./PaymentStatusDialog";

const BookingList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const bookings = useSelector((state) => state.booking.bookings || []);
  const totalRecord = useSelector((state) => state.booking?.totalRecords || 0);
  const totalPages = useSelector((state) => state.booking?.totalPages || 0);
  const deleteSuccess = useSelector((state) => state.booking?.message);

  const { loading: viewListLoading, deleteLoading } = useSelector(
    (state) => state.booking
  );

  const {
    loading: resendPaymentLoading,
    success: resendPaymentSuccess,
    resendPaymentError,
    data: resendPaymentData,
  } = useSelector((state) => state.booking);

  const { user } = useSelector((state) => state.auth);
  const isStaff = user.role !== "Customer" && user.role !== "Vendor";

  const tab = location?.state?.tab ?? (isStaff ? 0 : 2);
  const pageNumber = location?.state?.page ?? 0;
 
  const complemetStatus = location?.state?.complementaryStatus ?? 2;
  const instantBookingStatus = location?.state?.instantStatus ?? 2;

  const permissions = useMemo(() => {
    let safePermissions = {};
    try {
      if (user?.permissions) {
        safePermissions =
          typeof user.permissions === "string"
            ? JSON.parse(user.permissions)
            : user.permissions;
      }
    } catch (error) {
      safePermissions = {};
    }
    return safePermissions;
  }, [user]);

  const {
    loading: updatePaymentLoading,
    success: updatePaymentSuccess,
    error: updatePaymentError,
  } = useSelector((state) => state.booking.updatePaymentStatus || {});

  const {
    loading: updateBookingLoading,
    success: updateBookingSuccess,
    error: updateBookingError,
  } = useSelector((state) => state.booking.updateBookingStatus || {});

  const [type, setType] = useState(tab);
  const searchNavigateQuery = location.state?.searchQuery ?? "";

  const [searchQuery, setSearchQuery] = useState(searchNavigateQuery ?? "");

  const [searchColumn, setSearchColumn] = useState("");
  const [open, setOpen] = useState(false);
  const [bookingToDelete, setBookingToDelete] = useState(null);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  
  // Add ref to track current page value
  const immediatePageRef = useRef(0);
  
  // Helper function to update both state and ref
  const updatePage = (newPage) => {
    setPage(newPage);
    immediatePageRef.current = newPage;
  };
  
  // Update page when location state changes
  useEffect(() => {
    if (location?.state?.page !== undefined) {
      updatePage(location.state.page);
    }
  }, [location?.state?.page]);
  
  const [complementaryStatus, setComplementaryStatus] =
    useState(complemetStatus);
  const [instantStatus, setInstantStatus] = useState(instantBookingStatus);
  const [cancelReason, setCancelReason] = useState("");
  const [allBookings, setAllBookings] = useState([]);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [updatePaymentDialogOpen, setUpdatePaymentDialogOpen] = useState(false);
  const [updateBookingDialogOpen, setUpdateBookingDialogOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState("1");
  const [referenceNumber, setReferenceNumber] = useState("");
  const [bookingStatus, setBookingStatus] = useState("1");
  const [booked_type, setBooked_type] = useState(1);

  const currentDate = new Date().toISOString().split("T")[0];
  const searchTimerRef = useRef(null);
  const isInitialLoad = useRef(true);
  const rowsPerPage = pageSize;

  const bookingFilterHeaders = [
    { value: "booking_serial_no", label: "Booking Number" },
    { value: "date_of_booking", label: "Booking Date" },
    { value: "booked_user_name", label: "Booked By" },
    { value: "booked_for", label: "Booked For" },
    { value: "service", label: "Service" },
    { value: "service_type_label", label: "Service Type" },
  ];

  // Fetch data function
  const fetchData = (
    currentPage = page,
    tabType = type,
    search = searchQuery,
    searchBy = searchColumn,
    includeDates = false,
    pageSizeOverride = pageSize
  ) => {
    dispatch(resetBookingDetails());

    let bookedType = 1;
    if (tabType === 1 || tabType === 2 || tabType === 3) {
      bookedType = 1;
    } else if (tabType === 4) {
      bookedType = 2;
    } else if (tabType === 5) {
      bookedType = 3;
    }

    const dateParams = {};
    if (includeDates) {
      if (fromDate) dateParams.from_date = fromDate;
      if (toDate) dateParams.to_date = toDate;
    }

    const apiPage = currentPage + 1;

    if (user.role === "Customer" || user.role === "Vendor") {
      dispatch(
        fetchCustomerBookingsRequest({
          customer_id: user.customer_id || "",
          vendor_id: user.vendor_id || "",
          pageNo: apiPage,
          pageSize: pageSizeOverride,
          type:
            tabType === 2
              ? "upcoming"
              : tabType === 1
              ? "previous"
              : tabType === 3
              ? "cancelled"
              : "upcoming",
          booked_type: "all",
          currentDate,
          search: search || "",
          search_by: searchBy || "",
          ...dateParams,
        })
      );
    } else {
      if (tabType === 0) {
        dispatch(
          fetchAllBookingRequest({
            pageNo: apiPage,
            pagesize: pageSizeOverride,
            search: search || "",
            search_by: searchBy || "",
            ...dateParams,
          })
        );
      } else if (tabType === 4) {
        dispatch(
          fetchComplementaryBookingsRequest({
            pageNo: apiPage,
            pagesize: pageSizeOverride,
            approove_status: complementaryStatus,
            currentDate,
            search: search || "",
            search_by: searchBy || "",
            ...dateParams,
          })
        );
      } else if (tabType === 5) {
        let instantBookingType;
        switch (instantStatus) {
          case 1:
            instantBookingType = "previous";
            break;
          case 2:
            instantBookingType = "upcoming";
            break;
          case 3:
            instantBookingType = "cancelled";
            break;
          default:
            instantBookingType = "upcoming";
        }

        dispatch(
          fetchInstantBookingsRequest({
            pageNo: apiPage,
            pagesize: pageSizeOverride,
            type: instantBookingType,
            currentDate,
            search: search || "",
            search_by: searchBy || "",
            ...dateParams,
          })
        );
      } else {
        dispatch(
          fetchBookingsRequest({
            pageNo: apiPage,
            pagesize: pageSizeOverride,
            type:
              tabType === 2
                ? "upcoming"
                : tabType === 1
                ? "previous"
                : tabType === 3
                ? "cancelled"
                : "upcoming",
            booked_type: bookedType,
            currentDate,
            search: search || "",
            search_by: searchBy || "",
            ...dateParams,
          })
        );
      }
    }
  };

  const immediateSearchQueryRef = useRef(searchNavigateQuery ?? "");

  const handleSearch = (query, column) => {
    setSearchQuery(query);
    immediateSearchQueryRef.current = query;

    if (column !== undefined) {
      setSearchColumn(column);
    }

    if (searchTimerRef.current) {
      clearTimeout(searchTimerRef.current);
    }

    if (query || query === "") {
      searchTimerRef.current = setTimeout(() => {
        updatePage(0);
        fetchData(0, type, query, column || searchColumn);
      }, 1000);
    }
  };
  
  const handleColumnChange = (column) => {
    setSearchColumn(column);
  };

  const handleDateFilterSubmit = () => {
    updatePage(0);
    fetchData(0, type, searchQuery, searchColumn, true);
  };

  const handleClearDates = (clearType) => {
    setFromDate("");
    setToDate("");
    updatePage(0);
    fetchData(0, clearType || type, searchQuery, searchColumn);
  };

  // Initial load and tab/status change
  useEffect(() => {
    if (isInitialLoad.current) {
      dispatch(resetBookingDetails());
      fetchData(0, type, "", "");
      isInitialLoad.current = false;
    } else {
      updatePage(0);
    }
  }, [type, complementaryStatus, instantStatus]);

  // Handle page changes
  useEffect(() => {
    if (!isInitialLoad.current) {
      fetchData(
        page,
        type,
        searchQuery,
        searchColumn,
        fromDate || toDate,
        pageSize
      );
    }
  }, [page, pageSize]);

  useEffect(() => {
    const processedData = preprocessData(bookings);
    setAllBookings(processedData);
  }, [bookings]);

  useEffect(() => {
    return () => {
      dispatch(resetBookingDetails());
    };
  }, []);

  useEffect(() => {
    return () => {
      if (searchTimerRef.current) {
        clearTimeout(searchTimerRef.current);
      }
    };
  }, []);

  // Resend payment effects
  useEffect(() => {
    if (resendPaymentSuccess) {
      toast.success(resendPaymentData?.message, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resendRazorpayLinkReset());
          fetchData();
        },
      });

      if (user.customer_id && resendPaymentData?.payment_url) {
        window.location.href = resendPaymentData.payment_url;
      }
    }
    if (resendPaymentError) {
      toast.error(`Failed to send payment link`, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resendRazorpayLinkReset());
          fetchData();
        },
      });
    }
  }, [resendPaymentSuccess, resendPaymentError]);

  // Update payment status effects
  useEffect(() => {
    if (updatePaymentSuccess) {
      toast.success("Payment status updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(updatePaymentStatusReset());
          fetchData(page, type, searchQuery, searchColumn);
          handleClosePaymentDialog();
        },
      });
    }

    if (updatePaymentError) {
      toast.error(`Failed to update payment status: ${updatePaymentError}`, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(updatePaymentStatusReset());
        },
      });
    }
  }, [updatePaymentSuccess, updatePaymentError]);

  // Update booking status effects
  useEffect(() => {
    if (updateBookingSuccess) {
      toast.success("Booking status updated successfully!", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(updateBookingStatusReset());
          fetchData(page, type, searchQuery, searchColumn);
          handleCloseBookingStatusDialog();
        },
      });
    }

    if (updateBookingError) {
      toast.error(`Failed to update Booking status: ${updateBookingError}`, {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(updateBookingStatusReset());
        },
      });
    }
  }, [updateBookingSuccess, updateBookingError]);

  // Delete success effect
  useEffect(() => {
    if (deleteSuccess === "Your bookingservice cancelled") {
      toast.success("Your bookingservice cancelled", {
        position: "top-center",
        autoClose: 3000,
        onClose: () => {
          dispatch(resetBookingDetails());
          fetchData(page, type, searchQuery, searchColumn, fromDate || toDate);
        },
      });
    }
  }, [deleteSuccess]);

  // Preprocess data
  const preprocessData = (data) => {
    if (!data || !Array.isArray(data) || data.length === 0) {
      return [];
    }

    return data.map((item, index) => {
      const bookingUpdateLogs = Array.isArray(item?.bookingUpdateLogs)
        ? item.bookingUpdateLogs
        : item?.bookingUpdateLogs
        ? [item.bookingUpdateLogs]
        : [];

      const latestLog =
        bookingUpdateLogs.length > 0 ? bookingUpdateLogs[0] : null;
      const bookingDetail = item.BookingDetail || {};
      const billingAddress = item.BillingAddress || {};
      const customerContact = item?.Customer?.phone || {};
      const service = item.Service?.type_of_service || {};
      const order = item.Order || {};
      const numberOfAdults = bookingDetail.number_of_adults || 0;
      const numberOfChildren = bookingDetail.number_of_child || 0;
      const numberOfInfants = bookingDetail.number_of_infant || 0;
      const totalPassengers =
        numberOfAdults + numberOfChildren + numberOfInfants;
      const bookedUser = bookingDetail["BookedUser"] || {};

      let bookedUserName = "-";
      const user_type = bookedUser?.user_type || 0;

      if (user_type === 3 && bookedUser?.Customer) {
        bookedUserName = bookedUser?.Customer?.full_name;
      } else if (user_type === 2 && bookedUser?.Vendor) {
        bookedUserName = bookedUser?.Vendor?.full_name;
      } else if (user_type === 4 && bookedUser?.Staff) {
        bookedUserName = bookedUser?.Staff?.full_name;
      } else {
        bookedUserName = `${bookedUser?.first_name || ""} ${
          bookedUser?.last_name || ""
        }`.trim();
      }

      return {
        id: item.id || `booking-${index}`,
        is_mobile: item?.is_mobile,
        booking_number: item.id || "-",
        booking_serial_no: item.booking_serial_no || "",
        date_of_booking: item.created_at ? item.created_at : "-",
        booked_user_name: bookedUserName,
        promo_code: item?.Promocode?.discount_code || "-",
        booked_for: item?.bookingFamilies?.[0]?.familyMember?.first_name || "-",
        pnr_number: item?.pnr_number || "-",
        airport_name: item?.Airport?.name || "-",
        airport_type: item?.Airport?.airport_type || "-",
        first_name: billingAddress.first_name || "-",
        last_name: billingAddress.last_name || "-",
        company_name: billingAddress.company_name || "-",
        number_of_adults: numberOfAdults || "-",
        number_of_child: numberOfChildren || "-",
        number_of_infant: numberOfInfants || "-",
        total_passenger: totalPassengers,
        service: item.Service?.services || order.service || "-",
        service_type_label:
          { 1: "Arrival", 2: "Departure", 3: "Transit" }[item.service_type] ||
          "-",
        service_types: service,
        notes: bookingDetail.notes || "-",
        datetime_of_arrival:
          bookingDetail?.date_of_arrival !== "2000-01-01"
            ? bookingDetail?.time_of_arrival
              ? `${bookingDetail?.date_of_arrival} ${bookingDetail?.time_of_arrival}`
              : `${bookingDetail?.date_of_arrival}`
            : "-",
        datetime_of_departure:
          bookingDetail?.date_of_departure !== "2000-01-01"
            ? bookingDetail?.time_of_departure
              ? `${bookingDetail?.date_of_departure} ${bookingDetail?.time_of_departure}`
              : `${bookingDetail?.date_of_departure}`
            : "-",
        arrival_city:
          item?.Service?.type_of_name === "arrival"
            ? item.Airport?.name
            : bookingDetail.arrival_from_city || "-",
        arrival_airline: bookingDetail.arrival_airlines || "-",
        arrival_flight_number: bookingDetail.arrival_flight_number || "-",
        arival_pnr_by_customer: item?.arival_pnr_by_customer || "-",
        departure_city:
          item?.Service?.type_of_name === "departure"
            ? item.Airport?.name
            : bookingDetail.departure_from_city || "-",
        departure_airline: bookingDetail.departure_airlines || "-",
        departure_flight_number: bookingDetail.departure_flight_number || "-",
        departure_pnr_by_customer: item?.departure_pnr_by_customer || "-",
        payment_status: item?.payment_status || 0,
        approove_status: item.approove_status,
        booked_type: item.booked_type,
        user_type: user_type,
        contact: customerContact,
        emergency_contact: billingAddress?.emergency_contact,
        staff_update_status: latestLog ? latestLog.staff_update_status : null,
        booking_status_update_by: latestLog?.Staff?.full_name || "-",
        customer_id: item?.customer_id,
        razorpay_order_id: item?.razorpay_order_id || item?.pnr_number,
      };
    });
  };

  const handleView = (booking) => {
    const bookingId = booking?.booking_number;
    
    const state = {
      tab: type,
      page: immediatePageRef.current, // Use ref instead of page state
      complementaryStatus: complementaryStatus,
      instantStatus: instantStatus,
      searchQuery: immediateSearchQueryRef.current,
    };

    if (permissions?.bookings?.view || user?.role === "Admin") {
      navigate(VIEW_BOOKINGS.replace(":bookingId", bookingId), { state });
    } else if (user?.role === "Vendor") {
      navigate(VENDOR_VIEW_BOOKINGS.replace(":bookingId", bookingId), {
        state,
      });
    } else if (user?.role === "Customer") {
      navigate(CUSTOMER_VIEW_BOOKINGS.replace(":bookingId", bookingId), {
        state,
      });
    }
  };

  // Edit handler
  const handleEdit = (booking) => {
    const bookingId = booking?.booking_number;
    
    const state = {
      bookingData: booking,
      tabEdit: type,
      page: immediatePageRef.current, // Use ref instead of page state
      complementaryStatus: complementaryStatus,
      instantStatus: instantStatus,
      searchQuery: searchQuery,
    };

    if (permissions?.bookings?.edit && user?.role === "Staff") {
      navigate(EDIT_BOOKINGS.replace(":bookingId", bookingId), { state });
    }
    if (user?.role === "Admin") {
      navigate(EDIT_BOOKINGS.replace(":bookingId", bookingId), { state });
    }
    if (user?.role === "Vendor") {
      navigate(VENDOR_EDIT_BOOKINGS.replace(":bookingId", bookingId), {
        state,
      });
    }
  };

  // Resend payment helpers
  const isFutureDate = (dateStr) => {
    if (!dateStr || dateStr.trim().toLowerCase().includes("null")) return false;
    const date = new Date(dateStr.trim());
    return !isNaN(date.getTime()) && date.getTime() > new Date().getTime();
  };

  const shouldShowResendPaymentButton = (item) => {
    const {
      payment_status,
      booked_type,
      datetime_of_arrival,
      datetime_of_departure,
    } = item;
    const isFutureArrivalOrDeparture =
      isFutureDate(datetime_of_arrival) || isFutureDate(datetime_of_departure);
    return (
      payment_status !== 1 && booked_type !== 2 && isFutureArrivalOrDeparture
    );
  };

  const handleResendPayment = (booking) => {
    const payload = {
      customer_id: booking.customer_id || user.customer_id,
      razorpay_order_id: booking.razorpay_order_id,
    };
    dispatch(resendRazorpayLinkRequest(payload));
  };

  // Delete handlers
  const handleOpenPopup = (booking) => {
    setBookingToDelete(booking);
    setOpen(true);
  };

  const handleClosePopup = () => {
    setBookingToDelete(null);
    setOpen(false);
    setCancelReason("");
  };

  const handleConfirmDelete = () => {
    if (bookingToDelete) {
      const bookingId = bookingToDelete.booking_number;
      dispatch(deleteBookingRequest({ bookingId, cancel_notes: cancelReason }));
    }
    handleClosePopup();
  };

  // Tab change handler
  const handleTabChange = (event, newType) => {
    setType(newType);
    updatePage(0);
    handleClearDates(newType);

    if (newType !== 4) {
      setComplementaryStatus(2);
    }
    if (newType !== 5) {
      setInstantStatus(2);
    }
  };

  // Payment update handlers
  const handleOpenPaymentUpdate = (booking) => {
    setSelectedBooking(booking);
    setPaymentStatus(String(booking.payment_status || "1"));
    setReferenceNumber("");
    setUpdatePaymentDialogOpen(true);
  };

  const handleClosePaymentDialog = () => {
    setUpdatePaymentDialogOpen(false);
    setSelectedBooking(null);
    setReferenceNumber("");
  };

  const handleUpdatePaymentStatus = () => {
    if (!selectedBooking) return;

    const payload = {
      booking_id: selectedBooking.booking_number,
      payment_status: paymentStatus,
      payment_refrence_number: referenceNumber,
    };

    dispatch(updatePaymentStatusRequest(payload));
  };

  // Booking status update handlers
  const handleOpenBookingStatusUpdate = (booking) => {
    setSelectedBooking(booking);
    setBookingStatus(String(booking.staff_update_status || "1"));
    setUpdateBookingDialogOpen(true);
  };

  const handleCloseBookingStatusDialog = () => {
    setUpdateBookingDialogOpen(false);
    setSelectedBooking(null);
  };

  const handleUpdateBookingStatus = () => {
    if (!selectedBooking) return;

    const payload = {
      booking_id: selectedBooking.booking_number,
      staff_update_status: bookingStatus,
    };

    dispatch(updateBookingStatusRequest(payload));
  };

  // Individual export handler
  const handleIndividualExport = (booking) => {
    try {
      const serviceTypeLabel = (booking.service_type_label || "").toLowerCase();
      const serviceMode = (booking.service_mode || "").toLowerCase();
      const service = (booking.service || "").toLowerCase();

      const isTransit =
        serviceTypeLabel.includes("transit") ||
        serviceMode.includes("transit") ||
        service.includes("transit");

      const isDepartureByLabel =
        serviceTypeLabel.includes("departure") ||
        serviceMode.includes("departure") ||
        service.includes("departure");

      const isDepartureByData =
        booking.datetime_of_departure &&
        booking.datetime_of_departure !== "-" &&
        booking.datetime_of_departure !== null;

      const isArrivalByLabel =
        serviceTypeLabel.includes("arrival") ||
        serviceMode.includes("arrival") ||
        service.includes("arrival");

      const isArrivalByData =
        booking.datetime_of_arrival &&
        booking.datetime_of_arrival !== "-" &&
        booking.datetime_of_arrival !== null;

      let isDeparture = false;
      let isArrival = false;

      if (isTransit) {
        isArrival = true;
        isDeparture = true;
      } else if (isDepartureByLabel) {
        isDeparture = true;
      } else if (isArrivalByLabel) {
        isArrival = true;
      } else if (isDepartureByData && !isArrivalByData) {
        isDeparture = true;
      } else if (isArrivalByData && !isDepartureByData) {
        isArrival = true;
      } else if (isArrivalByData) {
        isArrival = true;
      }

      const getAirportCity = () => {
        if (isTransit) {
          const arrivalCity = booking.arrival_city || "";
          const departureCity = booking.departure_city || "";

          if (arrivalCity && departureCity) {
            return `Arrival: ${arrivalCity} | Departure: ${departureCity}`;
          } else if (arrivalCity) {
            return `Arrival: ${arrivalCity}`;
          } else if (departureCity) {
            return `Departure: ${departureCity}`;
          }
          return booking.airport_name || "-";
        } else if (isDeparture && booking.departure_city) {
          return booking.departure_city;
        } else if (isArrival && booking.arrival_city) {
          return booking.arrival_city;
        }
        return (
          booking.departure_city ||
          booking.arrival_city ||
          booking.airport_name ||
          "-"
        );
      };

      const getServiceDate = () => {
        const cleanDate = (dateTime) => {
          if (!dateTime || dateTime === "-") return null;
          const dateStr = formatDateWithAmPm(dateTime).split(" ")[0];
          return dateStr.replace(/[,\s]+$/, "").trim();
        };

        if (isTransit) {
          const arrivalDate = cleanDate(booking.datetime_of_arrival);
          if (arrivalDate) return arrivalDate;
          const departureDate = cleanDate(booking.datetime_of_departure);
          if (departureDate) return departureDate;
        } else if (isDeparture) {
          const departureDate = cleanDate(booking.datetime_of_departure);
          if (departureDate) return departureDate;
        } else if (isArrival) {
          const arrivalDate = cleanDate(booking.datetime_of_arrival);
          if (arrivalDate) return arrivalDate;
        }

        const departureDate = cleanDate(booking.datetime_of_departure);
        if (departureDate) return departureDate;
        const arrivalDate = cleanDate(booking.datetime_of_arrival);
        if (arrivalDate) return arrivalDate;

        return "-";
      };
      const getFlightTime = () => {
        if (isTransit) {
          let arrivalTime = "";
          let departureTime = "";

          if (
            booking.datetime_of_arrival &&
            booking.datetime_of_arrival !== "-"
          ) {
            arrivalTime = formatDateWithAmPm(booking.datetime_of_arrival)
              .split(" ")
              .slice(1)
              .join(" ");
          }

          if (
            booking.datetime_of_departure &&
            booking.datetime_of_departure !== "-"
          ) {
            departureTime = formatDateWithAmPm(booking.datetime_of_departure)
              .split(" ")
              .slice(1)
              .join(" ");
          }

          if (arrivalTime && departureTime) {
            return `Arrival: ${arrivalTime} | Departure: ${departureTime}`;
          } else if (arrivalTime) {
            return `Arrival: ${arrivalTime}`;
          } else if (departureTime) {
            return `Departure: ${departureTime}`;
          }
          return "-";
        } else if (isDeparture) {
          if (
            booking.datetime_of_departure &&
            booking.datetime_of_departure !== "-"
          ) {
            return formatDateWithAmPm(booking.datetime_of_departure)
              .split(" ")
              .slice(1)
              .join(" ");
          }
        } else if (isArrival) {
          if (
            booking.datetime_of_arrival &&
            booking.datetime_of_arrival !== "-"
          ) {
            return formatDateWithAmPm(booking.datetime_of_arrival)
              .split(" ")
              .slice(1)
              .join(" ");
          }
        }
        if (
          booking.datetime_of_departure &&
          booking.datetime_of_departure !== "-"
        ) {
          return formatDateWithAmPm(booking.datetime_of_departure)
            .split(" ")
            .slice(1)
            .join(" ");
        }
        if (
          booking.datetime_of_arrival &&
          booking.datetime_of_arrival !== "-"
        ) {
          return formatDateWithAmPm(booking.datetime_of_arrival)
            .split(" ")
            .slice(1)
            .join(" ");
        }
        return "-";
      };

      const getAirline = () => {
        if (isTransit) {
          const arrivalAirline = booking.arrival_airline || "";
          const departureAirline = booking.departure_airline || "";

          if (arrivalAirline && departureAirline) {
            return `Arrival: ${arrivalAirline} | Departure: ${departureAirline}`;
          } else if (arrivalAirline) {
            return `Arrival: ${arrivalAirline}`;
          } else if (departureAirline) {
            return `Departure: ${departureAirline}`;
          }
          return "-";
        } else if (isDeparture && booking.departure_airline) {
          return booking.departure_airline;
        } else if (isArrival && booking.arrival_airline) {
          return booking.arrival_airline;
        }
        return booking.departure_airline || booking.arrival_airline || "-";
      };

      const getFlightNumber = () => {
        if (isTransit) {
          const arrivalFlightNumber = booking.arrival_flight_number || "";
          const departureFlightNumber = booking.departure_flight_number || "";

          if (arrivalFlightNumber && departureFlightNumber) {
            return `Arrival: ${arrivalFlightNumber} | Departure: ${departureFlightNumber}`;
          } else if (arrivalFlightNumber) {
            return `Arrival: ${arrivalFlightNumber}`;
          } else if (departureFlightNumber) {
            return `Departure: ${departureFlightNumber}`;
          }
          return "-";
        } else if (isDeparture && booking.departure_flight_number) {
          return booking.departure_flight_number;
        } else if (isArrival && booking.arrival_flight_number) {
          return booking.arrival_flight_number;
        }
        return (
          booking.departure_flight_number ||
          booking.arrival_flight_number ||
          "-"
        );
      };

      const getPNR = () => {
        if (isTransit) {
          const arrivalPNR = booking.arival_pnr_by_customer || "";
          const departurePNR = booking.departure_pnr_by_customer || "";
          const generalPNR = booking.pnr_number || "";

          if (arrivalPNR && departurePNR) {
            return `Arrival: ${arrivalPNR} | Departure: ${departurePNR}`;
          } else if (arrivalPNR) {
            return `Arrival: ${arrivalPNR}`;
          } else if (departurePNR) {
            return `Departure: ${departurePNR}`;
          } else if (generalPNR) {
            return generalPNR;
          }
          return "-";
        } else if (isDeparture && booking.departure_pnr_by_customer) {
          return booking.departure_pnr_by_customer;
        } else if (isArrival && booking.arival_pnr_by_customer) {
          return booking.arival_pnr_by_customer;
        }
        return (
          booking.departure_pnr_by_customer ||
          booking.arival_pnr_by_customer ||
          booking.pnr_number ||
          "-"
        );
      };

      const csvRows = [
        ["Guest Name", `\t${booking.booked_for || "-"}`],
        ["Placard Guest Name", `\t${booking.booked_for || "-"}`],
        [
          "Guest Contact No.",
          (booking?.contact || "-") +
            " / " +
            (booking?.emergency_contact || "-"),
        ],
        ["No. of Pax", `\t${booking.total_passenger || "1"}`],
        ["Service Date", `\t${getServiceDate()}`],
        ["Airport", `\t${getAirportCity() || "-"}`],
        ["Terminal", `\t${booking.service_types || "-"}`],
        ["Service Type", `\t${booking.service || "-"}`],
        ["Service Mode", `\t${booking.service_type_label || "-"}`],
        ["Airline", `\t${getAirline()}`],
        ["Flight Number", `\t${getFlightNumber()}`],
        ["Flight Time", `\t${getFlightTime()}`],
        ["PNR No.", `\t${getPNR()}`],
        ["Remarks", `\t${booking.notes || "-"}`],
      ];

      const csvContent = csvRows
        .map((row) =>
          row
            .map((field) => {
              let stringField = String(field || "");
              if (
                stringField.includes(",") ||
                stringField.includes('"') ||
                stringField.includes("\n") ||
                stringField.includes("\t")
              ) {
                return `"${stringField.replace(/"/g, '""')}"`;
              }
              return stringField;
            })
            .join(",")
        )
        .join("\n");

      const BOM = "\uFEFF";
      const csvWithBOM = BOM + csvContent;
      const blob = new Blob([csvWithBOM], { type: "text/csv;charset=utf-8;" });
      const fileName = `booking_${booking.booking_serial_no}.csv`;
      saveAs(blob, fileName);
    } catch (error) {
      toast.error("Failed to export booking details", {
        position: "top-center",
        autoClose: 3000,
      });
    }
  };

  // Bulk export handler
  const handleExport = () => {
    let apiParams = {
      pagination_required: false,
    };
    if (fromDate) apiParams.from_date = fromDate;
    if (toDate) apiParams.to_date = toDate;

    if (type === 0) {
      apiParams = {
        ...apiParams,
        search: searchQuery || "",
        search_by: searchColumn || "",
      };
    } else if (type === 4) {
      apiParams = {
        ...apiParams,
        approove_status: complementaryStatus,
        booked_type: 2,
        currentDate,
        search: searchQuery || "",
        search_by: searchColumn || "",
      };
    } else if (type === 5) {
      let instantBookingType;
      switch (instantStatus) {
        case 1:
          instantBookingType = "previous";
          break;
        case 2:
          instantBookingType = "upcoming";
          break;
        case 3:
          instantBookingType = "cancelled";
          break;
        default:
          instantBookingType = "upcoming";
      }

      apiParams = {
        ...apiParams,
        type: instantBookingType,
        booked_type: 3,
        currentDate,
        search: searchQuery || "",
        search_by: searchColumn || "",
      };
    } else {
      apiParams = {
        ...apiParams,
        type: type === 2 ? "upcoming" : type === 1 ? "previous" : "cancelled",
        booked_type: booked_type,
        currentDate,
        search: searchQuery || "",
        search_by: searchColumn || "",
      };
    }

    let apiCall;

    if (user.role === "Customer" || user.role === "Vendor") {
      apiCall = axiosInstance.get("/bookservice/bookinggetbycustomer", {
        params: {
          ...apiParams,
          customer_id: user.customer_id || "",
          vendor_id: user.vendor_id || "",
          booked_type: "all",
        },
      });
    } else {
      let endpoint;
      if (type === 0) {
        endpoint = "bookservice/servicebookingalldata";
      } else if (type === 4) {
        endpoint = "bookservice/complementrybookingservice";
      } else if (type === 5) {
        endpoint = "bookservice/list";
      } else {
        endpoint = "/bookservice/list";
      }

      apiCall = axiosInstance.get(endpoint, { params: apiParams });
    }

    apiCall
      .then((response) => {
        let bookingsData = response?.data?.data || [];
        const processedData = preprocessData(bookingsData);

        const csvHeaders = [
          "Booking Number",
          "Booking Date",
          "Booked User Name",
          "Booked For",
          "Airport Name",
          "Airport Type",
          "First Name",
          "Last Name",
          "Company Name",
          "No Of Adult",
          "No Of Child",
          "No Of Infant",
          "Total Passenger",
          "Service",
          "Service Type",
          "Notes",
          "Arrival Date/Time",
          "Arrival City",
          "Arrival Airline",
          "Arrival Flight Number",
          "Arrival PNR By Customer",
          "Departure Date/Time",
          "Departure City",
          "Departure Airline",
          "Departure Flight Number",
          "Departure PNR By Customer",
          "Payment Reference Number",
          "Payment Status",
          "Approval Status",
          "Booked Type",
        ];

        const csvRows = processedData.map((booking) => {
          const escapeCsvField = (field) => {
            if (field === null || field === undefined) return '""';
            const stringField = String(field || "-");
            if (
              stringField.includes(",") ||
              stringField.includes('"') ||
              stringField.includes("\n")
            ) {
              return `"${stringField.replace(/"/g, '""')}"`;
            }
            return stringField;
          };

          const getApprovalStatusText = (statusCode) => {
            if (statusCode === 1 || statusCode === "1") return "Approved";
            if (statusCode === 2 || statusCode === "2") return "Pending";
            if (statusCode === 3 || statusCode === "3") return "Rejected";
            return statusCode || "";
          };

          const getPaymentStatusText = (statusCode, bookedType) => {
            if (statusCode === 1) return "Completed";
            if (statusCode === 0 && bookedType === 2)
              return "Free (Complementary)";
            if (statusCode === 0) return "Pending";
            if (statusCode === 2) return "Failed";
            if (statusCode === 3) return "Refunded";
            return "Aborted";
          };

          const getBookedTypeLabel = (typeCode) => {
            switch (typeCode) {
              case 1:
                return "Regular";
              case 2:
                return "Complementary";
              case 3:
                return "Instant Booking";
              default:
                return typeCode || "";
            }
          };

          const approvalStatus = booking.approove_status;
          const approvalStatusText = getApprovalStatusText(approvalStatus);
          const paymentStatusText = getPaymentStatusText(
            booking.payment_status,
            booking.booked_type
          );

          return [
            escapeCsvField(booking.booking_serial_no),
            escapeCsvField(formatDateWithAmPm(booking.date_of_booking)),
            escapeCsvField(booking.booked_user_name),
            escapeCsvField(booking.booked_for),
            escapeCsvField(booking.airport_name),
            escapeCsvField(booking.airport_type),
            escapeCsvField(booking.first_name),
            escapeCsvField(booking.last_name),
            escapeCsvField(booking.company_name),
            escapeCsvField(booking.number_of_adults),
            escapeCsvField(booking.number_of_child),
            escapeCsvField(booking.number_of_infant),
            escapeCsvField(booking.total_passenger),
            escapeCsvField(booking.service),
            escapeCsvField(booking.service_type_label),
            escapeCsvField(booking.notes),
            escapeCsvField(formatDateWithAmPm(booking.datetime_of_arrival)),
            escapeCsvField(booking.arrival_city),
            escapeCsvField(booking.arrival_airline),
            escapeCsvField(booking.arrival_flight_number),
            escapeCsvField(booking.arival_pnr_by_customer),
            escapeCsvField(formatDateWithAmPm(booking.datetime_of_departure)),
            escapeCsvField(booking.departure_city),
            escapeCsvField(booking.departure_airline),
            escapeCsvField(booking.departure_flight_number),
            escapeCsvField(booking.departure_pnr_by_customer),
            escapeCsvField(booking.pnr_number),
            escapeCsvField(paymentStatusText),
            escapeCsvField(approvalStatusText),
            escapeCsvField(getBookedTypeLabel(booking.booked_type)),
          ].join(",");
        });

        const csvContent = [csvHeaders.join(","), ...csvRows].join("\n");
        const blob = new Blob([csvContent], {
          type: "text/csv;charset=utf-8;",
        });
        saveAs(blob, `bookings_${new Date().toISOString().split("T")[0]}.csv`);
      })
      .catch((error) => {
        toast.error("Failed to export bookings", {
          position: "top-center",
          autoClose: 3000,
        });
      });
  };

  // Action button render functions
  const renderCustomViewButton = (item) =>
    (user?.user_type !== 1 && user?.user_type !== 2 && user?.user_type !== 3
      ? permissions?.bookings?.view ||
        user?.user_type === 1 ||
        user?.user_type === 2
      : user?.user_type === 1 ||
        user?.user_type === 2 ||
        user?.user_type === 3) && (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleView(item)}
        className="grey-button"
      >
        VIEW
      </Button>
    );

  const renderCustomEditButton = (item) => {
    if (type === 3 || type === 1) return null;

    const checkFutureDate = (dateString) => {
      if (!dateString || dateString === "-" || dateString === "2000-01-01")
        return false;
      const datePart = dateString.trim().split(" ")[0];
      const itemDate = new Date(datePart);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      itemDate.setHours(0, 0, 0, 0);
      return itemDate > today;
    };

    const arrivalIsFuture = checkFutureDate(item.datetime_of_arrival);
    const departureIsFuture = checkFutureDate(item.datetime_of_departure);
    const canEdit = arrivalIsFuture || departureIsFuture;

    const hasPermission =
      user?.user_type !== 1 && user?.user_type !== 2
        ? permissions?.bookings?.edit ||
          user?.user_type === 1 ||
          user?.user_type === 2
        : user?.user_type === 1 || user?.user_type === 2;

    return (
      hasPermission &&
      canEdit && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleEdit(item)}
          className="orange-button"
        >
          EDIT
        </Button>
      )
    );
  };

  const renderCustomDeleteButton = (item) => {
    if (type === 3 || type === 1) return null;
    return (
      (user?.user_type !== 1 && user?.user_type !== 2
        ? permissions?.bookings?.edit ||
          user?.user_type === 1 ||
          user?.user_type === 2
        : user?.user_type === 1) && (
        <Button
          variant="outlined"
          size="small"
          onClick={() => handleOpenPopup(item)}
          className="grey-button"
        >
          CANCEL
        </Button>
      )
    );
  };

  const renderResendPaymentButton = (item) => {
    if (!shouldShowResendPaymentButton(item)) return null;
    return (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleResendPayment(item)}
        className="orange-button"
        disabled={resendPaymentLoading}
      >
        {resendPaymentLoading ? "SENDING..." : "RETRY"}
      </Button>
    );
  };

  const renderIndividualExportButton = (item) => {
    if (user?.role !== "Admin" && user?.role !== "Staff") return null;
    return (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleIndividualExport(item)}
        className="orange-button"
      >
        EXPORT
      </Button>
    );
  };

  const renderPaymentUpdateButton = (item) =>
    (["Admin"].includes(user?.role) ||
      ["Manager"].includes(user?.role_name)) && (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleOpenPaymentUpdate(item)}
        className="grey-button"
        sx={{ width: "130px" }}
      >
        UPDATE STATUS
      </Button>
    );

  const renderBookingUpdateButton = (item) =>
    (["Admin"].includes(user?.role) ||
      ["Manager"].includes(user?.role_name)) && (
      <Button
        variant="outlined"
        size="small"
        onClick={() => handleOpenBookingStatusUpdate(item)}
        className="orange-button"
        sx={{ width: "150px" }}
      >
        BOOKING STATUS
      </Button>
    );

  const ActionsCell = ({ params }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);

    const viewButton = renderCustomViewButton(params.row);
    const editButton = renderCustomEditButton(params.row);
    const cancelButton = renderCustomDeleteButton(params.row);
    const retryButton = renderResendPaymentButton(params.row);
    const exportButton = renderIndividualExportButton(params.row);
    const paymentUpdateButton = renderPaymentUpdateButton(params.row);
    const bookingStatusButton = renderBookingUpdateButton(params.row);

    const primaryActions = [viewButton, editButton].filter(Boolean);
    const menuActions = [
      cancelButton,
      retryButton,
      exportButton,
      paymentUpdateButton,
      bookingStatusButton,
    ].filter(Boolean);

    return (
      <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
        {primaryActions}
        {menuActions.length > 0 && (
          <>
            <IconButton
              size="small"
              onClick={handleClick}
              sx={{
                border: "1px solid #ccc",
                borderRadius: "4px",
                padding: "4px 8px",
              }}
            >
              <MoreVertIcon fontSize="small" />
            </IconButton>

            <Menu 
              anchorEl={anchorEl} 
              open={open} 
              onClose={handleClose}
              onClick={(e) => e.stopPropagation()}
              disableRestoreFocus
              componentsProps={{
                paper: {
                  onClick: (e) => e.stopPropagation()
                }
              }}
            >
              {cancelButton && (
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                    handleOpenPopup(params.row);
                  }}
                >
                  Cancel Booking
                </MenuItem>
              )}

              {retryButton && (
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                    handleResendPayment(params.row);
                  }}
                >
                  Retry Payment
                </MenuItem>
              )}

              {exportButton && (
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                    handleIndividualExport(params.row);
                  }}
                >
                  Export
                </MenuItem>
              )}

              {paymentUpdateButton && (
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                    handleOpenPaymentUpdate(params.row);
                  }}
                >
                  Update Payment Status
                </MenuItem>
              )}

              {bookingStatusButton && (
                <MenuItem
                  onClick={(e) => {
                    e.stopPropagation();
                    handleClose();
                    handleOpenBookingStatusUpdate(params.row);
                  }}
                >
                  Update Booking Status
                </MenuItem>
              )}
            </Menu>
          </>
        )}
      </Box>
    );
  };

  // DataGrid columns
  const columns = useMemo(() => {
    const baseColumns = [
      {
        field: "booking_serial_no",
        headerName: "Booking Number",
        width: 180,
        renderCell: (params) => {
          const sourceBadge =
            params.row.is_mobile == 0
              ? { label: "Mobile", color: "rgb(251,207,154)" }
              : { label: "Web", color: "rgb(52,207,229)" };

          return (
            <Box
              sx={{
                backgroundColor: sourceBadge?.color,
                borderRadius: 3,
                display: "inline-block",
                cursor: "pointer",
              }}
              onClick={() => handleView(params.row)}
            >
              <Typography
                sx={{
                  color: "white",
                  padding: 1,
                  textDecoration: "none",
                  borderRadius: 3,
                  fontSize: "0.875rem",
                }}
              >
                {params.value}
              </Typography>
            </Box>
          );
        },
      },
      {
        field: "date_of_booking",
        headerName: "Booking Date",
        width: 180,
        renderCell: (params) => {
          const value = params?.row?.date_of_booking;
          return value ? formatDateWithAmPm(value) : "-";
        },
      },
      {
        field: "booked_user_name",
        headerName: "Booked By",
        width: 200,
        renderCell: (params) => {
          if (params.row.user_type === 2) {
            return (
              <span className="badge vendor-badge">
                {params.value} (Vendor)
              </span>
            );
          } else if (params.row.user_type === 3) {
            return (
              <span className="badge customer-badge">
                {params.value} (Customer)
              </span>
            );
          }
          return params.value;
        },
      },
      { field: "booked_for", headerName: "Booked For", width: 150 },
      { field: "number_of_adults", headerName: "No of Adults", width: 120 },
      { field: "number_of_child", headerName: "No of Children", width: 130 },
      { field: "number_of_infant", headerName: "No of Infants", width: 130 },
      { field: "total_passenger", headerName: "Total Passengers", width: 150 },
      { field: "service", headerName: "Service", width: 150 },
      { field: "service_type_label", headerName: "Service Type", width: 150 },
      {
        field: "datetime_of_arrival",
        headerName: "Arrival Date/Time",
        width: 180,
        renderCell: (params) => {
          const value = params?.row?.datetime_of_arrival;
          return value ? formatDateWithAmPmBooking(value) : "-";
        },
      },
      { field: "arrival_city", headerName: "Arrival City", width: 150 },
      { field: "arrival_airline", headerName: "Arrival Airline", width: 150 },
      {
        field: "arrival_flight_number",
        headerName: "Arrival Flight Number",
        width: 180,
      },
      {
        field: "arival_pnr_by_customer",
        headerName: "Arrival PNR Number",
        width: 180,
      },
      {
        field: "datetime_of_departure",
        headerName: "Departure Date/Time",
        width: 180,
        renderCell: (params) => {
          const value = params?.row?.datetime_of_departure;
          return value ? formatDateWithAmPmBooking(value) : "-";
        },
      },
      { field: "departure_city", headerName: "Departure City", width: 150 },
      {
        field: "departure_airline",
        headerName: "Departure Airline",
        width: 150,
      },
      {
        field: "departure_flight_number",
        headerName: "Departure Flight Number",
        width: 180,
      },
      {
        field: "departure_pnr_by_customer",
        headerName: "Departure PNR Number",
        width: 180,
      },
      {
        field: "pnr_number",
        headerName: "Payment Reference Number",
        width: 200,
      },
      {
        field: "payment_status",
        headerName: "Payment Status",
        width: 180,
        renderCell: (params) => (
          <Chip
            label={
              params.value === 1
                ? "Completed"
                : params.value === 0 && params.row?.booked_type === 2
                ? "Free (Complementary)"
                : params.value === 0
                ? "Pending"
                : params.value === 2
                ? "Failed"
                : params.value === 3
                ? "Refunded"
                : "Aborted"
            }
            color={
              params.value === 1
                ? "success"
                : params.value === 0 && params.row?.booked_type === 2
                ? "success"
                : params.value === 2
                ? "error"
                : params.value === 3
                ? "success"
                : params.value === 0
                ? "warning"
                : "error"
            }
            size="small"
          />
        ),
      },
      { field: "promo_code", headerName: "Promo Code", width: 150 },
      { field: "notes", headerName: "Notes", width: 200 },
      {
        field: "actions",
        headerName: "Actions",
        width: 200,
        sortable: false,
        filterable: false,
        renderCell: (params) => <ActionsCell params={params} />,
      },
    ];

    if (user?.user_type !== 2 && user?.user_type !== 3) {
      const insertIndex = baseColumns.findIndex(
        (col) => col.field === "promo_code"
      );
      baseColumns.splice(
        insertIndex,
        0,
        {
          field: "staff_update_status",
          headerName: "Booking Status",
          width: 150,
          renderCell: (params) => {
            if (params.value === undefined || params.value === null) return "-";
            const statusMap = {
              1: { label: "Pending", color: "warning" },
              2: { label: "Processing", color: "warning" },
              3: { label: "Completed", color: "success" },
              4: { label: "Cancelled", color: "error" },
            };
            return (
              <Chip
                label={statusMap[params.value]?.label || "-"}
                color={statusMap[params.value]?.color || "default"}
                size="small"
              />
            );
          },
        },
        {
          field: "booking_status_update_by",
          headerName: "Updated By",
          width: 150,
        }
      );
    }

    return baseColumns;
  }, [user, type, permissions]);

  if (viewListLoading) {
    return <Loading text="Loading Booking Details..." />;
  }

  return (
    <>
      <ToastContainer />
      <Box className="container">
        <Grid container spacing={5}>
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <SearchAndButtonTab
                  title="Bookings"
                  columns={bookingFilterHeaders}
                  searchColumn={searchColumn}
                  hideSearchColumnSelector={true}
                  setSearchColumn={handleColumnChange}
                  searchQuery={searchQuery}
                  setSearchQuery={handleSearch}
                  handleExport={handleExport}
                  routeName={
                    user.role === "Vendor"
                      ? VENDOR_BOOKING_AIRPORT_DETAILS
                      : user.role === "Customer"
                      ? CUSTOMER_BOOKING_AIRPORT_DETAILS
                      : BOOKING_AIRPORT_DETAILS
                  }
                  permissions={permissions}
                  user={user}
                />

                {(user?.role === "Admin" || user?.role === "Staff") && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      mb: 2,
                      alignItems: "center",
                      flexWrap: "wrap",
                    }}
                  >
                    <TextField
                      label="From Date"
                      type="date"
                      value={fromDate}
                      onChange={(e) => setFromDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ minWidth: 180 }}
                      inputProps={{ max: toDate || currentDate }}
                    />
                    <TextField
                      label="To Date"
                      type="date"
                      value={toDate}
                      onChange={(e) => setToDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                      sx={{ minWidth: 180 }}
                      inputProps={{ min: fromDate }}
                    />
                    <Button
                      variant="contained"
                      onClick={handleDateFilterSubmit}
                      disabled={!fromDate && !toDate}
                      className="orange-button"
                    >
                      Apply Dates
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={() => handleClearDates()}
                      disabled={!fromDate && !toDate}
                      className="grey-button"
                    >
                      Clear Dates
                    </Button>
                  </Box>
                )}

                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <Tabs
                    value={type}
                    onChange={handleTabChange}
                    indicatorColor="primary"
                    textColor="primary"
                  >
                    {user.role !== "Customer" && user.role !== "Vendor" && (
                      <Tab label="All" value={0} />
                    )}
                    <Tab label="Upcoming" value={2} />
                    <Tab label="Completed" value={1} />
                    <Tab label="Cancelled" value={3} />
                    {user.role !== "Customer" && user.role !== "Vendor" && (
                      <Tab label="Complementary" value={4} />
                    )}
                    {user.role !== "Customer" && user.role !== "Vendor" && (
                      <Tab label="Instant Booking" value={5} />
                    )}
                  </Tabs>
                </Box>

                {type === 4 && (
                  <Tabs
                    value={complementaryStatus}
                    onChange={(event, newStatus) =>
                      setComplementaryStatus(newStatus)
                    }
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{ ml: 2 }}
                  >
                    <Tab label="Pending" value={2} className="tab-heights" />
                    <Tab label="Approved" value={1} className="tab-heights" />
                    <Tab label="Rejected" value={3} className="tab-heights" />
                  </Tabs>
                )}

                {type === 5 && (
                  <Tabs
                    value={instantStatus}
                    onChange={(event, newStatus) => setInstantStatus(newStatus)}
                    indicatorColor="primary"
                    textColor="primary"
                    sx={{ ml: 2 }}
                  >
                    <Tab label="Upcoming" value={2} className="tab-heights" />
                    <Tab label="Completed" value={1} className="tab-heights" />
                    <Tab label="Cancelled" value={3} className="tab-heights" />
                  </Tabs>
                )}

                <Box sx={{ height: 650, width: "100%", mt: 2 }}>
                  {allBookings.length > 0 ? (
                    <DataGrid
                      rows={allBookings}
                      columns={columns}
                      pagination
                      page={page}
                      pageSize={pageSize}
                      rowCount={totalRecord}
                      paginationMode="server"
                      loading={viewListLoading}
                      disableSelectionOnClick
                      getRowHeight={() => "auto"}
                      paginationModel={{ page: page, pageSize: pageSize }}
                      onPaginationModelChange={(params) => {
                        updatePage(params.page);
                        setPageSize(params.pageSize);
                        fetchData(params.page, type, searchQuery, searchColumn, true, params.pageSize);
                      }}
                      pageSizeOptions={[10, 25, 50, 100]}
                      hideFooterPagination={true}
                      slots={{
                        footer: () => (
                          <div style={{ display: 'flex', justifyContent: 'flex-end', width: '100%', padding: '16px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <span>Rows per page:</span>
                              <select
                                value={pageSize}
                                onChange={(e) => {
                                  const newPageSize = Number(e.target.value);
                                  setPageSize(newPageSize);
                                  fetchData(page, type, searchQuery, searchColumn, true, newPageSize);
                                }}
                                style={{ padding: '4px', borderRadius: '4px', border: '1px solid #ccc' }}
                              >
                                {[10].map((size) => (
                                  <option key={size} value={size}>
                                    {size}
                                  </option>
                                ))}
                              </select>
                              <span>
                                {page * pageSize + 1}-{Math.min((page + 1) * pageSize, totalRecord)} of {totalRecord}
                              </span>
                              <button
                                onClick={() => {
                                  const newPage = Math.max(0, page - 1);
                                  updatePage(newPage);
                                  fetchData(newPage, type, searchQuery, searchColumn, true, pageSize);
                                }}
                                disabled={page === 0}
                                style={{
                                  padding: '4px 8px',
                                  margin: '0 4px',
                                  cursor: page === 0 ? 'not-allowed' : 'pointer',
                                  opacity: page === 0 ? 0.5 : 1,
                                }}
                              >
                                &lt;
                              </button>
                              <button
                                onClick={() => {
                                  const newPage = page + 1;
                                  updatePage(newPage);
                                  fetchData(newPage, type, searchQuery, searchColumn, true, pageSize);
                                }}
                                disabled={(page + 1) * pageSize >= totalRecord}
                                style={{
                                  padding: '4px 8px',
                                  margin: '0 4px',
                                  cursor: (page + 1) * pageSize >= totalRecord ? 'not-allowed' : 'pointer',
                                  opacity: (page + 1) * pageSize >= totalRecord ? 0.5 : 1,
                                }}
                              >
                                &gt;
                              </button>
                            </div>
                          </div>
                        ),
                      }}
                      sx={{
                        "& .MuiDataGrid-cell": {
                          borderBottom: "1px solid #f0f0f0",
                          py: 1,
                        },
                        "& .MuiDataGrid-columnHeaders": {
                          backgroundColor: "#f5f5f5",
                          fontWeight: "bold",
                        },
                        "& .MuiDataGrid-row:hover": {
                          backgroundColor: "#f9f9f9",
                        },
                      }}
                    />
                  ) : (
                    <Box textAlign="center" py={5}>
                      <img
                        src={nodata}
                        alt="No Data"
                        style={{ maxWidth: "300px", maxHeight: "300px" }}
                      />
                    </Box>
                  )}
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>

        <Dialog open={open} onClose={handleClosePopup} maxWidth="sm" fullWidth>
          <DialogTitle sx={{ fontWeight: "bold", textAlign: "center" }}>
            Confirm Cancellation
          </DialogTitle>
          <DialogContent sx={{ p: 3 }}>
            <DialogContentText
              sx={{ mb: 2, textAlign: "center", fontSize: "16px" }}
            >
              Are you sure you want to cancel this booking? <br />
              <strong>Booking ID: {bookingToDelete?.booking_serial_no}</strong>
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              label="Reason for Cancellation"
              type="text"
              name="cancelReason"
              fullWidth
              multiline
              rows={4}
              variant="outlined"
              value={cancelReason}
              onChange={(e) => setCancelReason(e.target.value)}
              required
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "10px",
                },
              }}
            />
          </DialogContent>
          <DialogActions sx={{ justifyContent: "end", px: 3, pb: 3 }}>
            <Button
              size="medium"
              onClick={handleClosePopup}
              className="handle-back"
              variant="outlined"
              sx={{
                borderRadius: "8px",
                minWidth: "100px",
              }}
            >
              Cancel
            </Button>
            <CustomButton
              variant="contained"
              className="handle-delete"
              type="submit"
              size="medium"
              loading={deleteLoading}
              text="Confirm Cancel"
              onClick={handleConfirmDelete}
              disabled={!cancelReason.trim()}
              sx={{
                borderRadius: "8px",
                minWidth: "130px",
                backgroundColor: "#d32f2f",
                "&:hover": {
                  backgroundColor: "#b71c1c",
                },
              }}
            />
          </DialogActions>
        </Dialog>

        <PaymentStatusDialog
          open={updatePaymentDialogOpen}
          onClose={handleClosePaymentDialog}
          title="Update Payment Status"
          selectedBooking={selectedBooking}
          handleUpdateStatus={handleUpdatePaymentStatus}
          loading={updatePaymentLoading}
          updateStatus={paymentStatus}
          setUpdateStatus={setPaymentStatus}
          setReferenceNumber={setReferenceNumber}
        />

        <PaymentStatusDialog
          open={updateBookingDialogOpen}
          onClose={handleCloseBookingStatusDialog}
          title="Update Booking Status"
          selectedBooking={selectedBooking}
          handleUpdateStatus={handleUpdateBookingStatus}
          loading={updateBookingLoading}
          updateStatus={bookingStatus}
          setUpdateStatus={setBookingStatus}
        />
      </Box>
    </>
  );
};

export default BookingList;